$(document).ready(function(){
    let canvas = document.getElementById('floor-mat-canvas');
    let fbCanvas;
    var fontMaxsize = 150;
    let isCanvasEnabled = false; // Check Fiber Canvas is Enable Or Not
    let currentTextOneVal = '';
    let currentTextTwoVal = '';
    let removeBgApiKey = 'NtVRP7zR7N5SS1JchX5eriWx';

    let orientationInputs = document.querySelectorAll('input[name="mateOrientation"]');
    let backingSelect = document.getElementById('backing');

    let text1Input = document.getElementById('text1');
    let text2Input = document.getElementById('text2');

    let fontFamily1Select = document.getElementById('font-family1');
    let fontSize1Input = document.getElementById('font-size1');
    let fontColor1Select = document.getElementById('font-color1');
    let fontcolor1Swatch = document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__swatch-input:checked');

    let fontFamily2Select = document.getElementById('font-family2');
    let fontSize2Input = document.getElementById('font-size2');
    let fontColor2Select = document.getElementById('font-color2');
    let fontcolor2Swatch = document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__swatch-input:checked');
    
    let currentProgress = 0;
    let progressBar = document.getElementById('progress-bar');
    let progressTooltip = document.querySelector('.progress-tooltip-info');

    let uploadLogoInput = document.getElementById('upload-logo__image');
    let uploadLogoLabel = document.querySelector('.upload-logo__label');
    let uploadPreviewImg = document.querySelector('.upload-logo__preview .upload-logo__preview-media #userPreview');
    let img = new Image();
    img.crossOrigin = "anonymous"; // Allow CORS

    let actionButtons = document.querySelector('.canvas_action-btn');
    let cropper;
    let cropperFancyboxModal;

    let backing = document.getElementById("backing").value ? document.getElementById("backing").value : 'smooth';

    let boxColor;
    if (document.querySelector('input[name="color-swatch"]')) {
        boxColor = document.querySelector('input[name="color-swatch"]:checked').value ? document.querySelector('input[name="color-swatch"]:checked').value : '#FFFFFF';
    }
    let borderColor = '#000000';

    let text1 = text1Input.value || '';
    let textOneFontFamily = document.getElementById("font-family1").value ? document.getElementById("font-family1").value : 'Arial';
    let textOneFontSize = document.getElementById("font-size1").value ? document.getElementById("font-size1").value : '16';

    let textOneColor;
    if (document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__swatch-input')) {
        textOneColor =  document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__swatch-input:checked').value ? document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__swatch-input:checked').value : '#000000'
    }
    let font1 = { family: textOneFontFamily, size: textOneFontSize, color: textOneColor, style: 'normal', weight: 'normal' };
    let text1Obj;

    let text2 = text2Input.value || '';
    let textTwoFontFamily = document.getElementById("font-family2").value ? document.getElementById("font-family2").value : 'Trebuchet MS';
    let textTwoFontSize = document.getElementById("font-size2").value ? document.getElementById("font-size2").value : '16';
    
    let textTwoColor;
    if (document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__swatch-input')) {
        textTwoColor = document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__swatch-input:checked').value ? document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__swatch-input:checked').value : '#000000'
    }
    let font2 = { family: textTwoFontFamily, size: textTwoFontSize, color: textTwoColor, style: 'normal', weight: 'normal' };
    let text2Obj;

    let ctx;
    let xPos, yPos;
    let box;
    let imgWidth, imgHeight, imgX, imgY;
    let centerLineX = null;
    let centerLineY = null;
    let uploadedImageObject = null;
    let floorMateLoader = document.querySelector('.customize-floor-mate-loader');

    let currentUploadedImage;
    let isImageCustomized = false;
    let isFieldChanged = false;
    let fieldsToTrack = [
        '#backing', 'input[name="color-swatch"]', '#border-color', '#text1', '#font-family1', '#font-size1',
        '#text2', '#font-family2', '#upload-logo__image', '.font-size-controls button', '#font-size2', "#size",
        '.font1-style', '.font1-weight','.font2-style', '.font2-weight' , '.color-swatch-dropdown__swatch-input'
    ];
    let conformationModal;
    let isRightClick;

    // line item properties object
    let checkoutButton = document.querySelector('.main-product__checkout-button');
    let line_item_properties = {};

    let deleteIcon = "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='utf-8'%3F%3E%3C!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3E%3Csvg version='1.1' id='Ebene_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='595.275px' height='595.275px' viewBox='200 215 230 470' xml:space='preserve'%3E%3Ccircle style='fill:%23F44336;' cx='299.76' cy='439.067' r='218.516'/%3E%3Cg%3E%3Crect x='267.162' y='307.978' transform='matrix(0.7071 -0.7071 0.7071 0.7071 -222.6202 340.6915)' style='fill:white;' width='65.545' height='262.18'/%3E%3Crect x='266.988' y='308.153' transform='matrix(0.7071 0.7071 -0.7071 0.7071 398.3889 -83.3116)' style='fill:white;' width='65.544' height='262.179'/%3E%3C/g%3E%3C/svg%3E";

    let enLargeMedia = document.querySelector('.js-media-enlarge');
    let shrinkMedia = document.querySelector('.js-media-shrink');
    
    let switchLogoToBlack = document.querySelector('.js-logo-switch-black');
    let switchLogoToWhite = document.querySelector('.js-logo-switch-white');
    let switchLogoToOriginal = document.querySelector('.js-logo-switch-reset');

    function handleOrientationChange() {
        let orientation = document.querySelector('input[name="mateOrientation"]:checked').value;
        let defaultMedia = document.querySelector('.customize-floor-mate-block__default-media');
        let previewWrap = document.querySelector('.customize-floor-mate-block__preview-wrap');
        let preview = document.querySelector('.customize-floor-mate-block__preview');

        if (orientation) {
            if ($('.customize-floor-mate--redesign').length === 0) {
                defaultMedia.style.display = 'none';
            } 
           previewWrap.style.display = 'flex';
              // if ($('.customize-floor-mate--redesign').length > 0) {
              //     previewWrap.style.display = 'flex';
              // } else{
              //    previewWrap.style.display = 'none';
              // }
                 
              
               
           
        }

        if (window.innerWidth > 767) {
            preview.style.minHeight = preview.offsetWidth * 0.9 + 'px';
        } else {
            preview.style.minHeight = preview.offsetWidth * 1 + 'px';
        }

        if (orientation) {
            let fields = document.querySelectorAll('#backing, input[name="color-swatch"], #border-color, #text1, #font-family1, #font-size1, #text2, #font-family2, #upload-logo__image, .font-size-controls button, #font-size2, #size, .font1-style, .font1-weight,.font2-style, .font2-weight , .color-swatch-dropdown__swatch-input');
            fields.forEach(field => field.disabled = false);
        }

        if (window.innerWidth > 992) {
            if (orientation === "landscape") {
                canvas.width = preview.offsetWidth * 0.88;
                canvas.height = preview.offsetHeight * 0.55;
            } else if (orientation === "portrait") {
                canvas.width = preview.offsetWidth * 0.55;
                canvas.height = preview.offsetHeight * 0.88;
            }
        } else if (window.innerWidth > 767 && window.innerWidth <= 992) { 
            if (orientation === "landscape") {
                canvas.width = preview.offsetWidth * 0.75;
                canvas.height = preview.offsetHeight * 0.50;
            } else if (orientation === "portrait") {
                canvas.width = preview.offsetWidth * 0.60;
                canvas.height = preview.offsetHeight * 0.75;
            }
        } else {
            if (orientation === "landscape") {
                canvas.width = preview.offsetWidth * 0.88;
                canvas.height = preview.offsetHeight * 0.55;
            } else if (orientation === "portrait") {
                canvas.width = preview.offsetWidth * 0.60;
                canvas.height = preview.offsetHeight * 0.85;
            }
        }

        let detailBlockWrapper = document.querySelectorAll(".main-product__select-block.main-product__customise-overlay");
        if(detailBlockWrapper){
            let orientationErrorBlock = document.querySelector(".main-product__select-block > .error-message");
            if(orientationErrorBlock) {
                orientationErrorBlock.textContent = "";
                orientationErrorBlock.style.display = "none";
            }
            detailBlockWrapper.forEach(function (detailBlock) {
                if(detailBlock.classList.contains("main-product__customise-overlay")){
                    detailBlock.classList.remove("main-product__customise-overlay");
                    // Remove the event listener
                    detailBlock.removeEventListener("click", handleDetailBlockClick);
                }
            });
        }      

        initializeCanvas(); 
    }

    let handleObjectMoving = (e) => {
        let target = e.target;
        if (target === text1Obj || target === text2Obj) {
            let boxBounds = box.getBoundingRect();
            let textBounds = target.getBoundingRect();
            if (textBounds.left < boxBounds.left || textBounds.top < boxBounds.top ||
                textBounds.left + textBounds.width > boxBounds.left + boxBounds.width ||
                textBounds.top + textBounds.height > boxBounds.top + boxBounds.height) {
                target.set({
                    opacity: 0
                });
            } else {
                target.set({
                    opacity: 1
                });
            }
            fbCanvas.requestRenderAll();
        }
    }

    function startUpload() {
        let interval = setInterval(() => {
            if (currentProgress < 100) {
                currentProgress++;
                updateProgress(currentProgress);
            } else {
                clearInterval(interval);
            }
        }, 8);
    }

    function updateProgress(progress) {
        progressBar.value = progress;
        progressTooltip.style.left = `${progress}%`;
        progressTooltip.textContent = `${progress}%`;
    }

    function canvasClear(){
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        currentProgress = 0;
        updateProgress(currentProgress);
        uploadPreviewImg.src = '';
        img.src = '';
        img.crossOrigin = "anonymous";

        if (uploadLogoInput) {
            uploadLogoInput.value = '';
        }
        if (fbCanvas.viewport) {
            fbCanvas.viewport.zoomToPoint({ x: 0, y: 0 }, 1);
            fbCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
        }
        if (text1Input) {
            text1Input.value = '';
        }
        if (text2Input) {
            text2Input.value = '';
        }

        if (uploadedImageObject) {
            fbCanvas.remove(uploadedImageObject);
            uploadedImageObject = null;
        }
        if (text1Obj) {
            fbCanvas.remove(text1Obj);
            text1Obj = null;
        }
        if (text2Obj) {
            fbCanvas.remove(text2Obj);
            text2Obj = null;
        }
        if (box) {
            fbCanvas.remove(box);
            box = null;
        }

        if (uploadLogoLabel && uploadLogoLabel.classList.contains('media-uploaded')) {
            uploadLogoLabel.classList.remove('media-uploaded');
        }
        if (actionButtons.classList.contains('enable-action-button')) {
            actionButtons.classList.remove('enable-action-button');
        }
        if (actionButtons.classList.contains('enable-media-button')) {
            actionButtons.classList.remove('enable-media-button');
        }
        if(currentUploadedImage){
            currentUploadedImage = '';
        }
        isImageCustomized = false;

        if (uploadLogoInput.nextElementSibling) {
            uploadLogoInput.nextElementSibling.textContent = '';
            uploadLogoInput.nextElementSibling.style.display = "none";
            uploadLogoInput.nextElementSibling.style.color = "red";
        }

        removeCenterGuides(fbCanvas);
    }

    function resetUpload() {
        currentProgress = 0;
        updateProgress(currentProgress);
        uploadPreviewImg.src = '';
        img.src = '';
        img.crossOrigin = "anonymous";

        if (uploadLogoInput) {
            uploadLogoInput.value = '';
        }
        if (fbCanvas.viewport) {
            fbCanvas.viewport.zoomToPoint({ x: 0, y: 0 }, 1);
            fbCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
        }
        if (text1Input) {
            text1Input.value = '';
        }
        if (text2Input) {
            text2Input.value = '';
        }

        if (uploadedImageObject) {
            fbCanvas.remove(uploadedImageObject);
            uploadedImageObject = null;
        }
        if (text1Obj) {
            fbCanvas.remove(text1Obj);
            text1Obj = null;
        }
        if (text2Obj) {
            fbCanvas.remove(text2Obj);
            text2Obj = null;
        }

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        if (uploadLogoLabel && uploadLogoLabel.classList.contains('media-uploaded')) {
            uploadLogoLabel.classList.remove('media-uploaded');
        }
        if (actionButtons.classList.contains('enable-action-button')) {
            actionButtons.classList.remove('enable-action-button');
        }
        if (actionButtons.classList.contains('enable-media-button')) {
            actionButtons.classList.remove('enable-media-button');
        }
        if(currentUploadedImage){
            currentUploadedImage = '';
        }
        isImageCustomized = false;

        if (uploadLogoInput.nextElementSibling) {
            uploadLogoInput.nextElementSibling.textContent = '';
            uploadLogoInput.nextElementSibling.style.display = "none";
            uploadLogoInput.nextElementSibling.style.color = "red";
        }

        removeCenterGuides(fbCanvas);

        updatePreview();
    }

    function resetMediaUpload() {
        currentProgress = 0;
        updateProgress(currentProgress);
        uploadPreviewImg.src = '';
        img.src = '';
        img.crossOrigin = "anonymous";

        if (uploadLogoInput) {
            uploadLogoInput.value = '';
        }
        if (fbCanvas.viewport) {
            fbCanvas.viewport.zoomToPoint({ x: 0, y: 0 }, 1);
            fbCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
        }
        if (uploadedImageObject) {
            fbCanvas.remove(uploadedImageObject);
            uploadedImageObject = null;
        }
        if (uploadLogoLabel && uploadLogoLabel.classList.contains('media-uploaded')) {
            uploadLogoLabel.classList.remove('media-uploaded');
        }
     
        if (actionButtons.classList.contains('enable-media-button')) {
            actionButtons.classList.remove('enable-media-button');
        }
        if(currentUploadedImage){
            currentUploadedImage = '';
        }
        isImageCustomized = false;

        if (!text1Obj & !text2Obj) {
            if (actionButtons.classList.contains('enable-action-button')) {
                actionButtons.classList.remove('enable-action-button');
            }
        }

        if (uploadLogoInput.nextElementSibling) {
            uploadLogoInput.nextElementSibling.textContent = '';
            uploadLogoInput.nextElementSibling.style.display = "none";
            uploadLogoInput.nextElementSibling.style.color = "red";
        }

        removeCenterGuides(fbCanvas);

        updatePreview();
    }
    
    document.querySelectorAll('.canvas_action-btn .js-reset-all').forEach( (button) => {
        if(button){
            button.addEventListener('click', resetUpload);
        }
    });
  
    document.querySelectorAll('.upload-logo__block .js-reset-media').forEach( (button) => {
        if(button){
            button.addEventListener('click', resetMediaUpload);
        }
    });

    /*
    // client need to remove image crop functionality remove
    function initializeCropper() {
        const image = document.getElementById('image');
        image.crossOrigin = "anonymous"; // Allow CORS
        const options = {
            preview: '.img-preview',
            cropBoxResizable: true,
            dragMode: 'move',
            crop: function (event) { console.log(event.detail); },
            cropstart : function (event) { console.log("Crop Start : ", event.type, event.detail.action); },
            cropmove: function (event) { console.log("Crop Move : ", event.type, event.detail.action); }
        };
        cropper = new Cropper(image, options);

        document.querySelector('.docs-buttons').addEventListener('click', function (event) {
            event.preventDefault();
            const button = event.target.closest('button');
            if (!button || !button.classList.contains('btn-preview-control')) return;

            const dataMethod = button.getAttribute('data-method');

            if (!dataMethod) return;

            if (dataMethod === 'zoomIn') {
                cropper.zoom(0.1);
            } else if (dataMethod === 'zoomOut') {
                cropper.zoom(-0.1);
            } else if (dataMethod === 'rotateLeft') {
                cropper.rotate(-90);
            } else if (dataMethod === 'rotateRight') {
                cropper.rotate(90);
            } else if (dataMethod === 'scaleX') {
                const currentScaleX = cropper.getData().scaleX;
                cropper.scaleX(currentScaleX === 1 ? -1 : 1);
            } else if (dataMethod === 'scaleY') {
                const currentScaleY = cropper.getData().scaleY;
                cropper.scaleY(currentScaleY === 1 ? -1 : 1);
            } else if (dataMethod === 'reset') {
                cropper.reset();
            }
        });
    }

    function destroyCropper() {
        if (cropper) {
            cropper.destroy();
            cropper = null;
        }
    }

    document.querySelector('.cropper-modal__footer #saveCroppedImage').addEventListener('click', function(e) {
        e.preventDefault();
        let CroppedImageModel = cropper.getCroppedCanvas({
            fillColor: 'transparent',
            imageSmoothingQuality: 'high',
        });
        if (CroppedImageModel) {
            let dataURL = CroppedImageModel.toDataURL('image/png');
            img.src = dataURL;
            img.crossOrigin = "anonymous";
            
            if (uploadedImageObject) {
                uploadedImageObject.crossOrigin = "anonymous";
                uploadedImageObject.setSrc(dataURL, function() {
                    fbCanvas.requestRenderAll();
                });
                isImageCustomized = true;
            }
            //console.log("saveCroppedImage Before close : ");
            cropperFancyboxModal.close();
        }
    });
   
    document.querySelector('.upload-logo__block .edit-img').addEventListener('click', function() {
        if(typeof currentUploadedImage === 'string' && ( currentUploadedImage !== null && currentUploadedImage !== '' && currentUploadedImage !== undefined )) {
            img.src = currentUploadedImage;
            if (uploadedImageObject) {
                uploadedImageObject.setSrc(img.src, function() {
                    // debugger;
                    img.crossOrigin = "anonymous";
                    fbCanvas.requestRenderAll();
                });
            }

            cropperFancyboxModal = $.fancybox.open({
                src  : '#cropperModal',
                type : 'inline', 
                opts : {
                    click: false,
                    touch: false, 
                    afterShow: function() {
                        image.src = img.src;
                        image.crossOrigin = "anonymous";
                        initializeCropper();
                        if (!isImageCustomized) {
                            document.getElementById('userPreview').src = currentUploadedImage;
                            document.getElementById('userPreview').setAttribute('crossOrigin','anonymous');
                        }
                    },
                    afterClose: function() {
                        destroyCropper();

                        actionButtons.classList.add('enable-action-button');
                        actionButtons.classList.add('enable-media-button');
                        updatePreview();

                        uploadLogoLabel.classList.add('media-uploaded');
                        startUpload();
                    }
                }
            });
        }
    });
    */

    function changeFontSize(action, input) {
        let currentFontSize = parseInt(input.value);
        if (!isNaN(currentFontSize)) {
            if (action === 'increase' && currentFontSize < fontMaxsize) {
                input.value = currentFontSize + 1;
            } 
            else if (action === 'decrease' && currentFontSize > 12) {
                input.value = currentFontSize - 1;
            }
        }

        if (parseInt(input.value) < 12) {
            input.value = 12;
        } else if (parseInt(input.value) > fontMaxsize) {
            input.value = fontMaxsize;
        }

        input.setAttribute('value', input.value);
        let event = new Event('input');
        input.dispatchEvent(event);
    }

    document.querySelectorAll('.font-size-controls').forEach(control => {
        control.querySelector('.increase-btn').addEventListener('click', function() {
            let input = control.querySelector('input[type="number"]');
            changeFontSize('increase', input);

            let event = new Event('input');
            text1Input.dispatchEvent(event);
            
            text2Input.dispatchEvent(event);
        });

        control.querySelector('.decrease-btn').addEventListener('click', function() {
            let input = control.querySelector('input[type="number"]');
            changeFontSize('decrease', input);

            let event = new Event('input');
            text1Input.dispatchEvent(event);
            text2Input.dispatchEvent(event);
        });

        control.querySelector('input[type="number"]').addEventListener('change', function(event) {
            let input = event.target;
            let currentFontSize = parseInt(input.value);
            if (isNaN(currentFontSize) || currentFontSize < 12) {
                input.value = 12;
            }

            // input.setAttribute('value', input.value);
            let Fevent = new Event(input);
            input.dispatchEvent(Fevent);

            let ev = new Event('input');
            text1Input.dispatchEvent(ev);
            text2Input.dispatchEvent(ev);
            
        });
    }); 
    
    document.querySelector('.cropper-modal__footer .btn-modal-close').addEventListener('click', function() {
        cropperFancyboxModal.close();
    });

    function removeInputVal(event, textObj, fontObj, maxWidth, maxHeight, fbCanvas, inputText) {
        if ((event.key === 'Backspace' || event.key === 'Delete')) {
            let adjustText = new fabric.Text(inputText.value, {
                fontFamily: fontObj.family,
                fontSize: fontObj.size,
                fontWeight: fontObj.weight,
                fill: fontObj.color,
                textAlign: 'center',
                originX: 'center',
                originY: 'center',
            });
            
            let textWidth = parseInt(adjustText.getBoundingRect().width) - 20;
            let textHeight = parseInt(adjustText.getBoundingRect().height);

            if (textWidth < maxWidth && textHeight < maxHeight && fontObj.size < 150) {
                while (textWidth < maxWidth && textHeight < maxHeight && fontObj.size < 150) {
                    fontObj.size++;
                    adjustText.set({ fontSize: fontObj.size });
                    textWidth = adjustText.width;
                    textHeight = adjustText.height;
                }
    
                if (fontObj.size > 150) {
                    fontObj.size = 12;
                }
            }
    
            textObj.set({ fontSize: fontObj.size });
            textObj.setCoords();
            fbCanvas.requestRenderAll();
           
        }
    }

    function handleContextMenu(event, inputText, isRightClick, currentTextObj, fontObj, maxWidth, maxHeight, fbCanvas) {
        isRightClick = true;
    
        inputText.addEventListener('cut', function(event) {
            let adjustText = new fabric.Text(inputText.value, {
                fontFamily: fontObj.family,
                fontSize: fontObj.size,
                fontWeight: fontObj.weight,
                fill: fontObj.color,
                letterSpacing: '1',
                lineHeight: 1.1,
            });
    
            let textWidth = parseInt(adjustText.getBoundingRect().width) - 20;
            let textHeight = parseInt(adjustText.getBoundingRect().height);
    
            if (textWidth < maxWidth && textHeight < maxHeight && fontObj.size < 150) {
                while (textWidth < maxWidth && textHeight < maxHeight && fontObj.size < 150) {
                    fontObj.size++;
                    adjustText.set({ fontSize: fontObj.size });
                    textWidth = adjustText.width;
                    textHeight = adjustText.height;
                }
    
                if (fontObj.size > 150) {
                    fontObj.size = 12;
                }
            }
    
            currentTextObj.set({ fontSize: fontObj.size });
            currentTextObj.setCoords();
            fbCanvas.requestRenderAll();
    
            // Reset the right-click flag
            isRightClick = false;
        });
    }

    function adjustFontSizeForText(textObj, inputTextVal, inputText , fontObj, maxWidth, maxHeight, fbCanvas) {
        inputText.nextElementSibling.innerHTML = '';
        inputText.nextElementSibling.style.display = 'none';

        if (!textObj) {
            return { fontObjsize: 16, textObjleft: 10 };
        }
        
        let adjustText = new fabric.Text(inputTextVal, {
            fontFamily: fontObj.family,
            fontSize: fontObj.size,
            fontWeight: fontObj.weight,
            fill: fontObj.color,
            letterSpacing: '1',
            lineHeight: 1.1,
        });
    
        let textWidth = parseInt(adjustText.getBoundingRect().width) - 20;
        let textHeight = parseInt(adjustText.getBoundingRect().height);


        if((textWidth < maxWidth && fontObj.size == 12)){
            if(textObj === text1Obj && currentTextOneVal.length <= inputTextVal.length) {
                inputText.value = currentTextOneVal;
                showErrorMessage(inputText, `You can't add more text value`);
                inputText.nextElementSibling.style.display = 'block';
                inputText.focus();
                return {fontObjsize: 12, textObjleft: 10};
            } else if (textObj === text2Obj && currentTextTwoVal.length <= inputTextVal.length) {
                inputText.value = currentTextTwoVal;
                showErrorMessage(inputText, `You can't add more text value`);
                inputText.nextElementSibling.style.display = 'block';
                inputText.focus();
                return {fontObjsize: 12, textObjleft: 10};
            }
            
        } else {
            if (inputTextVal.length < currentTextOneVal.length) {
                inputText.nextElementSibling.style.display = 'none';
            }
            if (inputTextVal.length < currentTextTwoVal.length) {
                inputText.nextElementSibling.style.display = 'none';
            }

            if(textObj === text1Obj) {
                currentTextOneVal = inputTextVal;
            } else if(textObj === text2Obj) {
                currentTextTwoVal = inputTextVal;
            }
            
            inputText.removeEventListener('keydown', removeInputVal);
            inputText.removeEventListener('contextmenu', handleContextMenu);
            
            while ((textWidth > maxWidth || textHeight > maxHeight) && fontObj.size > 12) {
                fontObj.size--;
                adjustText.set({ fontSize: fontObj.size });
        
                textWidth = adjustText.width;
                textHeight = adjustText.height;
            }

            inputText.addEventListener('keydown', function(e) {
                removeInputVal(e, textObj, fontObj, maxWidth, maxHeight, fbCanvas, inputText);
            });
            
            inputText.addEventListener('contextmenu', function(e) {
                isRightClick = false;
                handleContextMenu(e, inputText, isRightClick, textObj, fontObj, maxWidth, maxHeight, fbCanvas);
            });

            let newXPos = parseInt(textObj.left);
            let newYPos = parseInt(textObj.top);

            //console.table("maxWidth : ", maxWidth , " textWidth : ", textWidth);
            //console.table("newXPos : ", newXPos , " newYPos : ", newYPos);
        
            if (textWidth > maxWidth) {
                newXPos = parseInt((maxWidth - textWidth) / 2);
            } else {
                newXPos = parseInt((maxWidth - textWidth) / 2);
            }
        
            if (newXPos + textWidth > fbCanvas.width) {
                newXPos = (parseInt(fbCanvas.width - textWidth));
            }

            if (newXPos < 0) {
                newXPos = 8;
            }
            if (newYPos < 10) {
                newYPos = 13;
            }

            if (newYPos + textHeight > fbCanvas.height) {
                newYPos = parseInt((fbCanvas.height - textHeight)); 
            }

            textObj.set({ left: newXPos, top: newYPos });
            textObj.setCoords();

            fbCanvas.requestRenderAll();
            return  { fontObjsize: fontObj.size, textObjleft: newXPos };
        }
    }

    function updateTextOneCanvas() {
        let boxWidth, boxHeight;
        if (backing !== 'borderless_smooth') {
            boxWidth = fbCanvas.width - 5;
            boxHeight = fbCanvas.height - 5;
            xPos = (fbCanvas.width - (boxWidth + 5)) / 2;
            yPos = (fbCanvas.height - (boxHeight + 5)) / 2;
        } else {
            boxWidth = fbCanvas.width;
            boxHeight = fbCanvas.height;
            xPos = ((fbCanvas.width - boxWidth) / 2);
            yPos = ((fbCanvas.height - boxHeight) / 2);
        }

        let maxWidth;
        if (backing !== 'borderless_smooth') {
            maxWidth = boxWidth - 35;
        } else {
            maxWidth = boxWidth;
        }

        if (text1Input.value && (text1Input.value !== "" && typeof text1Input !== 'undefined' && text1Input !== 'null')) {
            // let newFontSize = Math.max(12, Math.min(font1.size, fontMaxsize));
            let  newFontSize = 16;
            let  textObjleft =  xPos + (boxWidth - text1Input.value.length * newFontSize) / 2; 
            let response;
          
            if( response !== 'undefined') {
                response = adjustFontSizeForText(text1Obj, text1Input.value, text1Input, font1, boxWidth, boxHeight, fbCanvas);
                newFontSize = response.fontObjsize;
                textObjleft = response.textObjleft;

                fontSize1Input.value = parseInt(newFontSize);
                fontSize1Input.setAttribute('value', parseInt(newFontSize));
                let event = new Event('input');
                fontSize1Input.dispatchEvent(event);
            }
          
            if (text1Obj) {
                let newWidth = Math.min(text1Obj.width, maxWidth - 15);
                let newHeight = Math.min(text1Obj.height, boxHeight);

                text1Obj.set({
                    text: text1Input.value,
                    left: textObjleft,
                    fontFamily: font1.family,
                    fontSize: newFontSize,
                    fontStyle: font1.style,
                    fontWeight: font1.weight,
                    fill: font1.color,
                    width: newWidth, 
                    height: newHeight,
                });
                fbCanvas.setActiveObject(text1Obj);
                text1Obj.setCoords();
                updateCrossIconPosition(text1Obj);
            } else {
                text1Obj = new fabric.Text(text1Input.value, {
                    // left: xPos + 10,
                    left: xPos + (boxWidth - text1Input.value.length * newFontSize) / 2,
                    top: yPos + 30,
                    fontFamily: font1.family,
                    fontSize: font1.size,
                    fontWeight: font1.weight,
                    fontStyle: font1.style,
                    fontStyle: 'normal',
                    fill: font1.color,
                    letterSpacing: '1',
                    selectable: true,
                    lockRotation: true,
                    lockScalingFlip: true,
                    lockSkewingX: true,
                    lockSkewingY: true,
                    maxWidth: maxWidth - 15,
                    lineHeight: 1.1,
                });

                text1Obj.setControlsVisibility({
                    bl: true,
                    br: true,
                    tl: true,
                    tr: true,
                    ml: false,
                    mt: false,
                    mr: false,
                    mb: false,
                });

                if (window.innerWidth < 1024) {
                    createCrossIcon(deleteIcon, text1Obj);
                }
                fbCanvas.add(text1Obj);
                fbCanvas.setActiveObject(text1Obj);
                if(!actionButtons.classList.add('enable-action-button')){
                    actionButtons.classList.add('enable-action-button');
                }
            }
        } else if (text1Obj) {
            if(text1Input.value === "") {
                handleObjectRemoval(text1Obj);
            }
            fbCanvas.remove(text1Obj);
            text1Obj = null;
        }

        if (uploadedImageObject) {
            updateCrossIconPosition(uploadedImageObject);
        } else {
            if(uploadedImageObject === "" && img === ""){
                handleObjectRemoval(uploadedImageObject)
            }
        }
    }

    function updateTextTwoCanvas() {
        let boxWidth, boxHeight;
        if (backing !== 'borderless_smooth') {
            boxWidth = fbCanvas.width - 5;
            boxHeight = fbCanvas.height - 5;
            xPos = (fbCanvas.width - (boxWidth + 5)) / 2;
            yPos = (fbCanvas.height - (boxHeight + 5)) / 2;
        } else {
            boxWidth = fbCanvas.width;
            boxHeight = fbCanvas.height;
            xPos = ((fbCanvas.width - boxWidth) / 2);
            yPos = ((fbCanvas.height - boxHeight) / 2);
        }

        let maxWidth;
        if (backing !== 'borderless_smooth') {
            maxWidth = boxWidth - 35;
        } else {
            maxWidth = boxWidth;
        }
        
        if (text2Input.value && (text2Input.value !== "" && typeof text2Input !== 'undefined' && text2Input !== 'null')) {
            let  newFontSize = 16;
            let  textObjleft =  xPos + (boxWidth - text2Input.value.length * newFontSize) / 2; 
            let response;
          
            if( response !== 'undefined') {
                response = adjustFontSizeForText(text2Obj, text2Input.value, text2Input, font2, boxWidth, boxHeight, fbCanvas);
                newFontSize = response.fontObjsize;
                textObjleft = response.textObjleft;
                fontSize2Input.value = parseInt(newFontSize);
                fontSize2Input.setAttribute('value', parseInt(newFontSize));
                let event = new Event('input');
                fontSize2Input.dispatchEvent(event);
            }
          
            if (text2Obj) {
                let newWidth = Math.min(text2Obj.width, maxWidth);
                let newHeight = Math.min(text2Obj.height, boxHeight);
                text2Obj.set({
                    text: text2Input.value,
                    left: textObjleft,
                    fontFamily: font2.family,
                    fontSize: font2.size,
                    fontStyle: font2.style,
                    fontWeight: font2.weight,
                    fill: font2.color,
                    width: newWidth, 
                    height: newHeight,
                });
                fbCanvas.setActiveObject(text2Obj);
                text2Obj.setCoords();
                updateCrossIconPosition(text2Obj);
            } else {
                text2Obj = new fabric.Text(text2Input.value, {
                    // left: xPos + 10,
                    left: xPos + (boxWidth - text2Input.value.length * newFontSize) / 2,
                    top: yPos + 60,
                    fontFamily: font2.family,
                    fontSize: font2.size,
                    fontWeight: font2.weight,
                    fontStyle: font2.style,
                    fill: font2.color,
                    letterSpacing: '1',
                    selectable: true,
                    lockRotation: true,
                    lockScalingFlip: true,
                    lockSkewingX: true,
                    lockSkewingY: true,
                    maxWidth: maxWidth, 
                    lineHeight: 1.1,
                });

                text2Obj.setControlsVisibility({
                    bl: true,
                    br: true,
                    tl: true,
                    tr: true,
                    ml: false,
                    mt: false,
                    mr: false,
                    mb: false,
                });
                
                if (window.innerWidth < 1024) {
                    createCrossIcon(deleteIcon, text2Obj);
                }
                fbCanvas.add(text2Obj);
                fbCanvas.setActiveObject(text2Obj); 
                if(!actionButtons.classList.add('enable-action-button')){
                    actionButtons.classList.add('enable-action-button');
                }
            }
        } else if (text2Obj) {
            if(text2Input.value === "") {
                handleObjectRemoval(text2Obj);
            }
            fbCanvas.remove(text2Obj);
            text2Obj = null;
        }
        fbCanvas.requestRenderAll();

        if (uploadedImageObject) {
            updateCrossIconPosition(uploadedImageObject);
        } else {
            if(uploadedImageObject === "" && img === ""){
                handleObjectRemoval(uploadedImageObject)
            }
        }
    }

    function createCrossIcon(imageUrl, targetObject) {
        fabric.Image.fromURL(imageUrl).then((crossIconMedia) => {
            let iconSize = 16;
            let scaleX = iconSize / crossIconMedia.width;
            let scaleY = iconSize / crossIconMedia.height;

            crossIconMedia.set({
                left: targetObject.left + targetObject.width * targetObject.scaleX - 14,
                top: targetObject.top - 24,
                scaleX: scaleX, 
                scaleY: scaleY, 
                selectable: false, 
                hoverCursor: 'pointer',
                evented: true,
                hasBorders: false,
                hasControls: false,
                crossOrigin: 'anonymous',
                opacity: 0,
            });
            targetObject.crossIconMedia = crossIconMedia;
            crossIconMedia.setCoords();
           
            crossIconMedia.on('mousedown', function() {
                fbCanvas.remove(targetObject); 
                fbCanvas.remove(crossIconMedia);
    
                if (targetObject === text1Obj) {
                    text1Input.value = '';
                    fbCanvas.remove(text1Obj);
                    text1Obj = null;
                } else if (targetObject === text2Obj) {
                    text2Input.value = '';
                    fbCanvas.remove(text2Obj);
                    text2Obj = null;
                } 
                else if (targetObject === uploadedImageObject) {
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    currentProgress = 0;
                    updateProgress(currentProgress);
                    fbCanvas.remove(uploadedImageObject);
                    uploadedImageObject = null;
                    img.src = '';
                    uploadPreviewImg.src = '';
                    if (uploadLogoInput) { 
                        uploadLogoInput.value = ''; 
                    }
                    if (fbCanvas.viewport) {
                        fbCanvas.viewport.zoomToPoint({ x: 0, y: 0 }, 1);
                        fbCanvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
                    }
                    if (uploadLogoLabel && uploadLogoLabel.classList.contains('media-uploaded')) { 
                        uploadLogoLabel.classList.remove('media-uploaded'); 
                    }
                    if (actionButtons.classList.contains('enable-media-button')) {
                        actionButtons.classList.remove('enable-media-button');
                    }
                    if(currentUploadedImage){
                        currentUploadedImage = '';
                    }
                    isImageCustomized = false;
                }
                targetObject.crossIconMedia = null;
                fbCanvas.requestRenderAll();

                if(!text1Obj && !text2Obj && uploadedImageObject == null){
                    if (actionButtons.classList.contains('enable-action-button')) {
                        actionButtons.classList.remove('enable-action-button');
                    }
                }
            });
    
            targetObject.on('selected', function() {
                crossIconMedia.set({ opacity: 1 });
                fbCanvas.requestRenderAll();
            });
    
            targetObject.on('deselected', function() {
                crossIconMedia.set({ opacity: 0 });
                fbCanvas.requestRenderAll();
            });
    
            fbCanvas.add(crossIconMedia);

            targetObject.on('moving', function () {
                updateCrossIconPosition(targetObject);
            });
    
            targetObject.on('scaling', function () {
                updateCrossIconPosition(targetObject);
            });
          
        }).catch((err) => {
            console.error("Error loading cross icon:", err);
        });
    }

    function updateCrossIconPosition(targetObject) {
        if (targetObject.crossIconMedia) {
            const crossIconMedia = targetObject.crossIconMedia;
            const iconSize = 16;
            const scaleX = iconSize / crossIconMedia.width;
            const scaleY = iconSize / crossIconMedia.height;
    
            crossIconMedia.set({
                left: targetObject.left + targetObject.width * targetObject.scaleX - 14,
                top: targetObject.top - 24,
                scaleX: scaleX,
                scaleY: scaleY,
            });
    
            crossIconMedia.setCoords();
            fbCanvas.requestRenderAll();
        }
    }

    function handleObjectRemoval(targetObject) {
        if (targetObject && targetObject.crossIconMedia) {
            fbCanvas.remove(targetObject.crossIconMedia); 
            targetObject.crossIconMedia = null;
        }
    }

    function updateCenterLineOpacity(grideLineCanvas) {
        const activeObject = grideLineCanvas.getActiveObject();
    
        if (activeObject === uploadedImageObject) {
            grideLineCanvas.getObjects().forEach(function (obj) {
                if (obj.id === 'centerLineX' || obj.id === 'centerLineY') {
                    obj.set({ opacity: 1 });
                }
            });
        } else {
            grideLineCanvas.getObjects().forEach(function (obj) {
                if (obj.id === 'centerLineX' || obj.id === 'centerLineY') {
                    obj.set({ opacity: 0 });
                }
            });
        }
        grideLineCanvas.requestRenderAll();
    }

    function drawCenterGuides(grideLineCanvas) {
        let canvasWidth = (grideLineCanvas.width - 10);
        let canvasHeight = (grideLineCanvas.height - 10);
    
        if (centerLineX == null) {
            centerLineX = new fabric.Line([6, canvasHeight / 2, canvasWidth + 5, canvasHeight / 2], {
                left: 6,
                top: canvasHeight / 2,
                stroke: '#B2CCFF',
                fill:'transparent',
                strokeWidth: 1,
                strokeDashArray: [2, 4],
                selectable: false,
                evented: false,
                id: 'centerLineX',
                opacity: 0,
                shadow: new fabric.Shadow({
                    color: '#FF00FF',
                    blur: 1,
                    offsetX: 1,
                    offsetY: 1,
                    affectStroke: false,
                    nonScaling: true, 
                }),
            });
            fbCanvas.add(centerLineX);        
        }
    
        if (centerLineY == null) {
            centerLineY = new fabric.Line([canvasWidth / 2, 6, canvasWidth / 2, canvasHeight + 5], {
                left: (canvasWidth / 2) + 5,
                top: 6,
                stroke: '#B2CCFF',
                fill:'transparent',
                strokeWidth: 1,
                strokeDashArray: [2, 4],
                selectable: false,
                evented: false,
                id: 'centerLineY',
                opacity: 0,
                shadow: new fabric.Shadow({
                    color: '#FF00FF',
                    blur: 1,
                    offsetX: 1,
                    offsetY: 1,
                    affectStroke: false,
                    nonScaling: true, 
                }),
            });
            fbCanvas.add(centerLineY);
        }
    
    }

    function removeCenterGuides(grideLineCanvas) {
        centerLineX = grideLineCanvas.getObjects().find(obj => obj.id === 'centerLineX');
        centerLineY = grideLineCanvas.getObjects().find(obj => obj.id === 'centerLineY');

        if (centerLineX) {
            grideLineCanvas.remove(centerLineX);
            centerLineX = null;
        }

        if (centerLineY) {
            grideLineCanvas.remove(centerLineY);
            centerLineY = null;
        }
    }

    function initializeCanvas() { 
        let canvasBlock = document.getElementsByClassName('customize-floor-mate-block__preview');
        fbCanvas = new fabric.Canvas('floor-mat-canvas');
        isCanvasEnabled = true;
        if (canvas.getContext) {
            ctx = canvas.getContext('2d');
            window.updatePreview = function() {
                let boxWidth, boxHeight;
                if (backing !== 'borderless_smooth') {
                    boxWidth = fbCanvas.width - 5;
                    boxHeight = fbCanvas.height - 5;
                    xPos = (fbCanvas.width - (boxWidth + 5)) / 2;
                    yPos = (fbCanvas.height - (boxHeight + 5)) / 2;
                } else {
                    boxWidth = fbCanvas.width;
                    boxHeight = fbCanvas.height;
                    xPos = ((fbCanvas.width - boxWidth) / 2);
                    yPos = ((fbCanvas.height - boxHeight) / 2);
                }
                console.table([boxWidth, boxHeight, xPos, yPos])
                
                if (!box) {
                    box = new fabric.Rect({
                        left: xPos,
                        top: yPos,
                        fill: boxColor,
                        width: boxWidth,
                        height: boxHeight,
                        selectable: false,
                        hasControls: false,
                        lockRotation: true,
                        stroke: backing === 'borderless_smooth' ? 'transparent' : borderColor, 
                        strokeWidth: backing === 'borderless_smooth' ? 0 : 5,
                    });
                    fbCanvas.add(box);
                } else {
                    box = box.set({
                        width: boxWidth,
                        height: boxHeight,
                        left: xPos,
                        top: yPos,
                        fill: boxColor,
                        stroke: backing === 'borderless_smooth' ? 'transparent' : borderColor,
                        strokeWidth: backing === 'borderless_smooth' ? 0 : 5,
                    });
                }
                box.setCoords();
            
                if (text1Input.value && (text1Input.value !== "" && typeof text1Input !== 'undefined' && text1Input !== 'null')) {
                    let newFontSize = Math.max(12, font1.size);
                    if (!text1Obj) {
                        text1Obj = new fabric.Text(text1.value, {
                            // left: xPos + 10,
                            left: xPos + (boxWidth - text1Input.value.length * newFontSize) / 2, 
                            top: yPos + 30,
                            fontFamily: newFontSize,
                            fontSize: font1.size,
                            fontWeight: font1.weight,
                            fontStyle: font1.style,
                            fill: font1.color,
                            letterSpacing: '1',
                            selectable: true,
                            lockRotation: true,
                            lockScalingFlip: true,
                            lockSkewingX: true,
                            lockSkewingY: true,
                            maxWidth: backing === 'borderless_smooth' ? boxWidth - 10 : boxWidth - 35,
                            lineHeight: 1.1,
                        });

                        text1Obj.setControlsVisibility({
                            bl: true,
                            br: true,
                            tl: true,
                            tr: true,
                            ml: false,
                            mt: false,
                            mr: false,
                            mb: false,
                        });

                        fbCanvas.add(text1Obj);
                        if(!actionButtons.classList.add('enable-action-button')){
                            actionButtons.classList.add('enable-action-button');
                        }
                    } else {
                        let newWidth = Math.min(text1Obj.width, boxWidth);
                        let newHeight = Math.min(text1Obj.height, boxHeight);
                        text1Obj.set({
                            text: text1Input.value,
                            // left: text1Obj.left || xPos + 10,
                            left: text1Obj.left || xPos + (boxWidth - text1Input.value.length * newFontSize) / 2, 
                            top: text1Obj.top || yPos + 30,
                            fontFamily: font1.family,
                            fontSize: newFontSize,
                            fontStyle: font1.style,
                            fontWeight: font1.weight,
                            fill: font1.color,
                            width: (newWidth - 35),
                            height: (newHeight - 35),
                        });
                        text1Obj.setCoords();
                    }
                } else if (text1Obj) {
                    if(text1Input.value === "") {
                        handleObjectRemoval(text1Obj);
                    }
                    fbCanvas.remove(text1Obj);
                    text1Obj = null;
                }

                if (text2Input.value && (text2Input.value !== "" && typeof text2Input !== 'undefined' && text2Input !== 'null')) {
                    let newFontSize = Math.max(12, font2.size);
                    if (!text2Obj) {
                        text2Obj = new fabric.Text(text2.value, {
                            // left: xPos + 10,
                            left: xPos + (boxWidth - text2Input.value.length * newFontSize) / 2,
                            top: yPos + 60,
                            fontFamily: font2.family,
                            fontSize: newFontSize,
                            fontWeight: font2.weight,
                            fontStyle: font2.style,
                            fill: font2.color,
                            letterSpacing: '1',
                            selectable: true,
                            lockRotation: true,
                            lockScalingFlip: true,
                            lockSkewingX: true,
                            lockSkewingY: true,
                            maxWidth: backing === 'borderless_smooth' ? boxWidth - 10 : boxWidth - 25,
                            lineHeight: 1.1,
                        });

                        text2Obj.setControlsVisibility({
                            bl: true,
                            br: true,
                            tl: true,
                            tr: true,
                            ml: false,
                            mt: false,
                            mr: false,
                            mb: false,
                        });

                        fbCanvas.add(text2Obj);
                        if(!actionButtons.classList.add('enable-action-button')){
                            actionButtons.classList.add('enable-action-button');
                        }
                    } else {
                        let newWidth = Math.min(text2Obj.width, boxWidth);
                        let newHeight = Math.min(text2Obj.height, boxHeight);
                        text2Obj.set({
                            text: text2Input.value,
                            // left: text2Obj.left || xPos + 10,
                            left: text2Obj.left || xPos + (boxWidth - text2Input.value.length * newFontSize) / 2,
                            top: text2Obj.top || yPos + 60,
                            fontFamily: font2.family,
                            fontSize: newFontSize,
                            fontStyle: font2.style,
                            fontWeight: font2.weight,
                            fill: font2.color,
                            width: (newWidth - 35), 
                            height: (newHeight - 35),
                        });
                        text2Obj.setCoords();
                    }
                } else if (text2Obj) {
                    if(text2Input.value === "") {
                        handleObjectRemoval(text2Obj);
                    }
                    fbCanvas.remove(text2Obj);
                    text2Obj = null;
                }

                if ((img.src && img.src !== "") && (!uploadedImageObject && uploadedImageObject !== "")) {
                      // debugger;
                    fabric.Image.fromURL(img.src).then((fabricGeneratedImage) => {
                        imgWidth = parseInt(boxWidth * 0.5);
                        imgHeight = parseInt(img.height * (imgWidth / img.width));
                        if (imgHeight > boxHeight * 0.5) {
                            imgHeight = parseInt(boxHeight * 0.5);
                            imgWidth = parseInt(img.width * (imgHeight / img.height));
                        }
                        imgX = parseInt(xPos + (boxWidth - imgWidth) / 2);
                        imgY = parseInt(yPos + (boxHeight - imgHeight) / 2);
    
                        // debugger;
                        fabricGeneratedImage.set({
                            left: imgX,
                            top: imgY,
                            scaleX: imgWidth / img.width,
                            scaleY: imgHeight / img.height,
                            selectable: true,
                            hasControls: true,
                            lockRotation: false,
                            fill: 'transparent', 
                            opacity: 1,
                            crossOrigin: 'anonymous'
                        });

                        uploadedImageObject = fabricGeneratedImage;
                        uploadedImageObject.crossOrigin = "anonymous";
                        
                        if (window.innerWidth < 1024) {
                            createCrossIcon(deleteIcon, uploadedImageObject);
                        }

                        fbCanvas.add(fabricGeneratedImage);
                        drawCenterGuides(fbCanvas);
                        fbCanvas.requestRenderAll();
                    }).catch((err) => {
                        removeCenterGuides(fbCanvas);
                        console.log("Error loading image:", err);
                    });
                    
                } else if (uploadedImageObject) {
                    if (uploadedImageObject) {
                        uploadedImageObject.set({
                            left: uploadedImageObject.left,
                            top: uploadedImageObject.top,
                            scaleX: uploadedImageObject.scaleX,
                            scaleY: uploadedImageObject.scaleY,
                        });
                        
                        fbCanvas.requestRenderAll();
                    } else {
                        if(uploadedImageObject === "" && img === ""){
                            handleObjectRemoval(uploadedImageObject)
                            removeCenterGuides(fbCanvas);
                        }
                    }
                }

                if(!text1Obj && !text2Obj && uploadedImageObject){
                    if (actionButtons.classList.contains('enable-action-button')) {
                        actionButtons.classList.remove('enable-action-button');
                    }
                }
                fbCanvas.requestRenderAll();
            }
            function scalingObject(e) {
                let obj = e.target;
                if (obj && obj.type === 'text') {
                    obj.setCoords();
                    let newWidth = obj.getScaledWidth();
                    let newHeight = obj.getScaledHeight();
                    let boxWidth = fbCanvas.width - 20;
                    let boxHeight = fbCanvas.height - 20;

                    let newLeft = obj.left;
                    let newTop = obj.top;

                    // Ensure the object doesn't move outside the right edge of the canvas
                    if (newLeft + newWidth > boxWidth) {
                        newLeft = boxWidth - newWidth;
                    }

                    // Ensure the object doesn't move outside the bottom edge of the canvas
                    if (newTop + newHeight > boxHeight) {
                        newTop = boxHeight - newHeight;
                    }

                    // Ensure the object doesn't move outside the left edge of the canvas
                    if (newLeft < 0) {
                        newLeft = 8;
                    }
                  
                    if (newTop < 0) {
                        newTop = 13;
                    }

                    obj.set({
                        left: newLeft,
                        top: newTop,
                        flipX: false, 
                        flipY: false,
                    });
                    obj.setCoords();
                    
                    
                    if (newWidth > boxWidth || newHeight > boxHeight) {
                        obj.setCoords();
                        let scaleX = boxWidth / obj.width;
                        let scaleY = boxHeight / obj.height;
            
                        if (scaleX < scaleY) {
                            obj.scale(scaleX);
                        } else {
                            obj.scale(scaleY);
                        }
                        
                    } else {
                        let scaleX = obj.scaleX;
                        let scaleY = obj.scaleY;
                        let newFontSize = obj.fontSize * Math.min(scaleX, scaleY);
                        newFontSize = Math.max(12, Math.min(newFontSize, fontMaxsize));
                        obj.set('fontSize', newFontSize);
                        
                        if (obj === text1Obj) {
                            fontSize1Input.value = Math.round(newFontSize);
                            font1.size = Math.round(newFontSize);
                            fontSize1Input.setAttribute('value', Math.round(newFontSize));
                        } else if (obj === text2Obj) {
                            fontSize2Input.value = Math.round(newFontSize);
                            font2.size = Math.round(newFontSize);
                            fontSize2Input.setAttribute('value', Math.round(newFontSize));
                        }
                    }
                    fbCanvas.requestRenderAll();

                } else if (obj && obj.type === 'image') { 
                    if (obj === uploadedImageObject) {
                        let newScaleX = obj.scaleX;
                        let newScaleY = obj.scaleY;
                        let newLeft = obj.left;
                        let newTop = obj.top;

                        uploadedImageObject.set({
                            scaleX: newScaleX,
                            scaleY: newScaleY,
                            left: newLeft,
                            top: newTop,
                        });
                        uploadedImageObject.setCoords();
                        fbCanvas.requestRenderAll();
                    }
                }
            }
            fbCanvas.on('object:scaling', scalingObject);

            fbCanvas.on('object:moving', function (e) {
                const obj = e.target;
                if (obj === text1Obj) {
                    let newWidth = obj.getScaledWidth();
                    let newHeight = obj.getScaledHeight();
                    let boxWidth = fbCanvas.width - 15;
                    let boxHeight = fbCanvas.height - 15;

                    let newLeft = obj.left;
                    let newTop = obj.top;

                    // Ensure the object doesn't move outside the right edge of the canvas
                    if (newLeft + newWidth > boxWidth) {
                        newLeft = boxWidth - newWidth;
                    }

                    // Ensure the object doesn't move outside the bottom edge of the canvas
                    if (newTop + newHeight > boxHeight) {
                        newTop = boxHeight - newHeight;
                    }

                    // Ensure the object doesn't move outside the left edge of the canvas
                    if (newLeft < 0) {
                        newLeft = 8;
                    }

                    // Ensure the object doesn't move outside the top edge of the canvas
                    if (newTop < 0) {
                        newTop = 13;
                    }
                    text1Obj.set({
                        left: newLeft,
                        top: newTop,
                    });
                    text1Obj.setCoords();
                    fbCanvas.requestRenderAll();

                } else if (obj === text2Obj) {
                    let newWidth = obj.getScaledWidth();
                    let newHeight = obj.getScaledHeight();
                    let boxWidth = fbCanvas.width - 15;
                    let boxHeight = fbCanvas.height - 15;

                    let newLeft = obj.left;
                    let newTop = obj.top;

                    // Ensure the object doesn't move outside the right edge of the canvas
                    if (newLeft + newWidth > boxWidth) {
                        newLeft = boxWidth - newWidth;
                    }

                    // Ensure the object doesn't move outside the bottom edge of the canvas
                    if (newTop + newHeight > boxHeight) {
                        newTop = boxHeight - newHeight;
                    }

                    // Ensure the object doesn't move outside the left edge of the canvas
                    if (newLeft < 0) {
                        newLeft = 13;
                    }

                    // Ensure the object doesn't move outside the top edge of the canvas
                    if (newTop < 0) {
                        newTop = 13;
                    }
                    text2Obj.set({
                        left: newLeft,
                        top: newTop,
                    });
                    text2Obj.setCoords();
                    fbCanvas.requestRenderAll();
                }
                if (obj && obj.type === 'image') {
                    if (obj === uploadedImageObject) {
                        let newLeft = obj.left;
                        let newTop = obj.top;
                        uploadedImageObject.set({
                            left: newLeft,
                            top: newTop,
                        });
                    }
                }
                fbCanvas.requestRenderAll();
            });   
            
            fbCanvas.on('selection:created', function() {
                updateCenterLineOpacity(fbCanvas);
            });
            
            fbCanvas.on('selection:updated', function() {
                updateCenterLineOpacity(fbCanvas);
            });
            
            fbCanvas.on('selection:cleared', function() {
                updateCenterLineOpacity(fbCanvas);
            });

            updatePreview();
        }
    }

    text1Input.addEventListener('input', updateTextOneCanvas);
    text2Input.addEventListener('input', updateTextTwoCanvas);

    
    document.addEventListener('keydown', function(event) {
        if (document.activeElement === text1Input || document.activeElement === text2Input) return;
        
        if (event.key === 'Delete') {
            let selectedObjects = fbCanvas.getActiveObjects();
            if (selectedObjects.length > 0) {
                selectedObjects.forEach(function(selectedObject) {
                    if (selectedObject.type === 'text') {
                        fbCanvas.remove(selectedObject);
    
                        if (selectedObject === text1Obj ) {
                            text1Input.value = '';
                            text1Obj = null;
                        } else if (selectedObject === text2Obj) {
                            text2Input.value = '';
                            text2Obj = null;
                        }
                    }
                    else if (selectedObject.type === 'image' && selectedObject === uploadedImageObject) {
                        fbCanvas.remove(uploadedImageObject);
                        uploadedImageObject = null;

                        img.src = '';
                        uploadPreviewImg.src = '';
                        
                        if (uploadLogoInput) {
                            uploadLogoInput.value = '';
                        }

                        if (uploadLogoLabel && uploadLogoLabel.classList.contains('media-uploaded')) {
                            uploadLogoLabel.classList.remove('media-uploaded');
                        }
                        if (actionButtons.classList.contains('enable-action-button')) {
                            actionButtons.classList.remove('enable-action-button');
                        }
                        if (actionButtons.classList.contains('enable-media-button')) {
                            actionButtons.classList.remove('enable-media-button');
                        }
                        if(currentUploadedImage){
                            currentUploadedImage = '';
                        }
            
                        isImageCustomized = false;

                        removeCenterGuides(fbCanvas);
                    }
                });
            }
        }
    });
    

    // Handle Image Upload and Validation
    uploadLogoInput.addEventListener('change', function (e) {
        if (uploadLogoInput.nextElementSibling && uploadLogoInput.nextElementSibling.classList.contains('error-message')) {
            uploadLogoInput.nextElementSibling.textContent = "";
            uploadLogoInput.nextElementSibling.style.display = "none";
        }

        let file = e.target.files[0];
        if (!file) {
            showErrorMessage(uploadLogoInput, 'Please select a file to upload.');
            uploadLogoInput.nextElementSibling.style.display = "block";
            return;  
        } 

        // Check file size (max 10MB)
        let maxSize = 10 * 1024 * 1024;
        if (file.size > maxSize) {
            showErrorMessage(uploadLogoInput, 'File size exceeds 10MB. Please upload a smaller file.');
            uploadLogoInput.nextElementSibling.style.display = "block";
            uploadLogoInput.nextElementSibling.style.color = "red";
            return;
        }

        let fileExtension = file.name.split('.').pop().toLowerCase();
        // if (!['jpg', 'jpeg', 'png', 'webp', 'bmp', 'pdf'].includes(fileExtension)) {
        if (!['jpg', 'jpeg', 'png', 'pdf'].includes(fileExtension)) {
            // showErrorMessage(uploadLogoInput, 'Invalid file type. Please upload an image (jpg, png, webp, bmp , pdf).');
            showErrorMessage(uploadLogoInput, 'Invalid file type. Please upload an image (jpg, png , pdf).');
            uploadLogoInput.nextElementSibling.style.display = "block";
            uploadLogoInput.nextElementSibling.style.color = "red";
            return;
        }
        uploadLogoInput.nextElementSibling.style.display = "none";

        floorMateLoader.classList.add('is-enable-loader');
        document.body.classList.add('is-enable-loader');

        if (fileExtension === 'pdf') {
            let fileReader = new FileReader();
            
            fileReader.onload = async function () {
                let pdfData = new Uint8Array(this.result);
                let pdf;
                try {
                    pdf = await pdfjsLib.getDocument({ data: pdfData }).promise;

                    if (pdf.numPages > 1) {
                        showErrorMessage(uploadLogoInput, 'Error: The PDF contains more then 1 page. Please upload a PDF with only one page.');
                        uploadLogoInput.nextElementSibling.style.display = "block";
                        uploadLogoInput.nextElementSibling.style.color = "red";
                        floorMateLoader.classList.remove('is-enable-loader');
                        document.body.classList.remove('is-enable-loader');
                    } else {
                        let fileName = file.name.split('.')[0].replace(/\s+/g, '-')+'.png';
                        // await convertPdfToImageAndUpload(pdf, fileName); 
                        uploadImageToServer(file, file.name)
                    }
                } catch (error) {
                    console.error('Error loading PDF:', error);
                }
            };
            fileReader.readAsArrayBuffer(file);

        // } else if (['jpg', 'jpeg', 'png', 'webp', 'bmp'].includes(fileExtension)) {
        } else if (['jpg', 'jpeg', 'png'].includes(fileExtension)) {
            // uploadImageToServer(file);
            let fileName = file.name.replace(/\s+/g, '-');
            handleImageUpload(file, fileName);
        } else {
            // showErrorMessage(uploadLogoInput, 'Invalid file type. Please upload an image (jpg, png, webp, bmp , pdf).');
            showErrorMessage(uploadLogoInput, 'Invalid file type. Please upload an image (jpg, png, pdf).');
            uploadLogoInput.nextElementSibling.style.display = "block";
            floorMateLoader.classList.remove('is-enable-loader');
            document.body.classList.remove('is-enable-loader');
            return;
        }
    });

    async function handleImageUpload(file, originalFileName) {
        const formData = new FormData();
        formData.append('image_file', file, originalFileName);
        formData.append('size', 'auto');
        // uploadImageToServer(file, originalFileName);
        
        try {
            const response = await fetch('https://api.remove.bg/v1.0/removebg', {
                method: 'POST',
                headers: {
                    'X-Api-Key': removeBgApiKey
                },
                body: formData
            });
    
            if (response.ok) {
                const result = await response.blob();
                const processedImageUrl = URL.createObjectURL(result);
                const processedFile = new File([result], originalFileName, { type: 'image/png' });

                uploadImageToServer(processedFile, originalFileName);
            } else {
                let errorResponse = await response.json();
                
                let bypassErrorCode = errorResponse.errors[0].code.trim().toLowerCase();
                if (bypassErrorCode && bypassErrorCode === "unknown_foreground") {
                    uploadImageToServer(file, originalFileName);
                } else {
                    showErrorMessage(uploadLogoInput, 'Error removing background from image.');
                    uploadLogoInput.nextElementSibling.style.display = "block";
                    floorMateLoader.classList.remove('is-enable-loader');
                    document.body.classList.remove('is-enable-loader');
                }

            }
        } catch (error) {
            showErrorMessage(uploadLogoInput, 'An error occurred while removing background.');
            uploadLogoInput.nextElementSibling.style.display = "block";
            floorMateLoader.classList.remove('is-enable-loader');
            document.body.classList.remove('is-enable-loader');
            console.error(error);
        }
    }

    async function uploadImageToServer(file, originalFileName) {
        const formData = new FormData();
        formData.append('file', file, originalFileName);

        try {
            const response = await fetch('https://www.firstmatsproofs.co.uk/firstmatsproofs.co.uk/eq-product-customizer/imgupload.php', {
                method: 'POST',
                body: formData,
            });
        
            if (response.ok) {
                const result = await response.json();
              //console.log("result : ", result);
        
                if (result.fileUrl) {
                    if ($("#floor-mat-image-from-outside").attr("src") !== result.fileUrl) {
                      $("#floor-mat-image-from-outside")
                      .attr("crossOrigin", "anonymous").off("load")
                      .on("load", function() {
                            //console.log("on Load");
                            // This code executes when the image has finished loading
                            // Create an offscreen canvas to draw this DOM image onto
                            const tempCanvas = document.createElement("canvas");
                            tempCanvas.width = this.naturalWidth;
                            tempCanvas.height = this.naturalHeight;
    
                            const tempCtx = tempCanvas.getContext("2d");
                            tempCtx.drawImage(this, 0, 0);
    
                            // Option A: Convert to Blob
                            tempCanvas.toBlob((blob) => {
                                //console.log("on Load blob");
                                
                                /* Check if we are to remove this for future */
                                const reader = new FileReader();
                                reader.onloadend = function() {
                                    //console.log("on Load reader.onloadend");
                                    // This is a Data URL like: "data:image/png;base64,iVBORw0KGgoAAAANS..."
                                    const base64DataURL = reader.result;
    
                                    floorMateLoader.classList.remove('is-enable-loader');
                                    document.body.classList.remove('is-enable-loader');
                                    currentUploadedImage = result.fileUrl;
    
                                    // If you only need the raw Base64, remove the data URL prefix:
                                    const base64String = base64DataURL.replace(/^data:.+;base64,/, "");
                                    // debugger;
                                    // You can now use `base64DataURL` or `base64String` for further processing
    
                                    //img.src = result.fileUrl;
                                    img.src = base64DataURL;

                                    // debugger;
                                    if (uploadedImageObject) {
                                        uploadedImageObject.setSrc(base64DataURL, function() { fbCanvas.requestRenderAll(); });
                                    }
                                    
                                    /*
                                    // client need to remove image crop functionality remove
                                    cropperFancyboxModal = $.fancybox.open({
                                        src  : '#cropperModal',
                                        type : 'inline', 
                                        opts : {
                                            click: false,
                                            touch: false, 
                                            afterShow: function() {
                                                $("#image").attr('src', base64DataURL);
                                                $("#image").attr('crossOrigin','anonymous');
                                                initializeCropper();
                                                if (!isImageCustomized) { 
                                                    uploadPreviewImg.src = base64DataURL; 
                                                }
                                            },
                                            afterClose: function() {
                                                destroyCropper();
                                                actionButtons.classList.add('enable-action-button');
                                                actionButtons.classList.add('enable-media-button');
                                                updatePreview();
                                                uploadLogoLabel.classList.add('media-uploaded');
                                                startUpload();
                                            }
                                        }
                                    });
                                    */

                                    if (!isImageCustomized) { 
                                        uploadPreviewImg.src = base64DataURL; 
                                    }

                                    actionButtons.classList.add('enable-action-button');
                                    actionButtons.classList.add('enable-media-button');
                                    updatePreview();
                                    uploadLogoLabel.classList.add('media-uploaded');
                                    startUpload();
    
                                    showErrorMessage(uploadLogoInput, 'File uploaded successfully!');
                                    uploadLogoInput.nextElementSibling.style.display = "block";
                                    uploadLogoInput.nextElementSibling.style.color = "rgb(60, 179, 113)";
                                };
                                reader.readAsDataURL(blob);
  
                            }, "image/png");
                          //window.alert("Image Got loaded!!!");
                      }).attr("src", result.fileUrl);
                    }
                    /*
                    const imageResponse = await fetch(result.fileUrl, {
                        method: 'GET',
                        //mode: 'no-cors'
                    });
                    
                    
                    const imageBlob = await imageResponse.blob();
                    */

                    /*
                    const reader = new FileReader();
                    reader.onloadend = function () {
                        const base64String = reader.result;
        
                        floorMateLoader.classList.remove('is-enable-loader');
                        document.body.classList.remove('is-enable-loader');
        
                        currentUploadedImage = result.fileUrl;
                        img.src = result.fileUrl;
        
                        if (uploadedImageObject) {
                            uploadedImageObject.setSrc(img.src, function() { fbCanvas.requestRenderAll(); });
                        }
        
                        cropperFancyboxModal = $.fancybox.open({
                            src  : '#cropperModal',
                            type : 'inline', 
                            opts : {
                                click: false,
                                touch: false, 
                                afterShow: function() {
                                    image.src = img.src;
                                    initializeCropper();
                                    if (!isImageCustomized) { 
                                        uploadPreviewImg.src = result.fileUrl; 
                                    }
                                },
                                afterClose: function() {
                                    destroyCropper();
                                    actionButtons.classList.add('enable-action-button');
                                    actionButtons.classList.add('enable-media-button');
                                    updatePreview();
                                    uploadLogoLabel.classList.add('media-uploaded');
                                    startUpload();
                                }
                            }
                        });
        
                        showErrorMessage(uploadLogoInput, 'File uploaded successfully!');
                        uploadLogoInput.nextElementSibling.style.display = "block";
                        uploadLogoInput.nextElementSibling.style.color = "rgb(60, 179, 113)";
                    };
                    reader.readAsDataURL(imageBlob);
                    */
                } else {
                    showErrorMessage(uploadLogoInput, 'Failed to retrieve the file URL.');
                    uploadLogoInput.nextElementSibling.style.display = "block";
                    floorMateLoader.classList.remove('is-enable-loader');
                    document.body.classList.remove('is-enable-loader');
                }
            } else {
                showErrorMessage(uploadLogoInput, 'File upload failed.');
                uploadLogoInput.nextElementSibling.style.display = "block";
                floorMateLoader.classList.remove('is-enable-loader');
                document.body.classList.remove('is-enable-loader');
            }
        } 
        catch (error) {
            console.error('Error:', error);
            showErrorMessage(uploadLogoInput, 'An error occurred during file upload.');
            uploadLogoInput.nextElementSibling.style.display = "block";
            floorMateLoader.classList.remove('is-enable-loader');
            document.body.classList.remove('is-enable-loader');
        }
    }

    function showErrorMessage(inputField, message) {
        let errorMessageDiv = inputField.nextElementSibling;

        if (errorMessageDiv && errorMessageDiv.classList.contains('error-message')) {
            errorMessageDiv.textContent = message;
        } else {
            let newErrorDiv = document.createElement('div');
            newErrorDiv.classList.add('error-message');
            newErrorDiv.textContent = message;
            inputField.insertAdjacentElement('afterend', newErrorDiv);
        }
    }

    function canvasMediaControl(mediaEvent) {
        let increaseFactor = 0.1;
        let decreaseFactor = 0.1;
        let xPos , boxWidth , yPos , boxHeight;
        let activeObject = fbCanvas.getActiveObject();

        if (backing !== 'borderless_smooth') {
            boxWidth = fbCanvas.width - 10;
            boxHeight = fbCanvas.height - 10;
        } else {
            boxWidth = fbCanvas.width;
            boxHeight = fbCanvas.height;
        }

        if (activeObject !== uploadedImageObject) {
            fbCanvas.setActiveObject(uploadedImageObject);
            activeObject = uploadedImageObject;
        }
        
        if (activeObject && activeObject.type === 'image') {
            let currentScaleX = activeObject.scaleX;
            let currentScaleY = activeObject.scaleY;
            let dataMediaControl = mediaEvent.currentTarget.getAttribute('media-control').trim().toLowerCase();
    
            if (dataMediaControl === 'enlarge') {
                uploadedImageObject.set({
                    scaleX: currentScaleX * (1 + increaseFactor),
                    scaleY: currentScaleY * (1 + increaseFactor)
                });
            } else if (dataMediaControl === 'shrink') {
                uploadedImageObject.set({
                    scaleX: currentScaleX * (1 - decreaseFactor),
                    scaleY: currentScaleY * (1 - decreaseFactor)
                });
            }
    
            let scaledWidth = uploadedImageObject.getScaledWidth();
            let scaledHeight = uploadedImageObject.getScaledHeight();
            xPos = ((boxWidth - scaledWidth) / 2) + 5;
            yPos = ((boxHeight - scaledHeight) / 2) + 5;
            // alert('position' + xPos)
            uploadedImageObject.set({
                top: yPos,
                left: xPos
            });
    
            uploadedImageObject.setCoords();
            fbCanvas.requestRenderAll();
        }
    }
    
    if(enLargeMedia) {
        enLargeMedia.addEventListener('click', (event) => {
            canvasMediaControl(event);
            updateCrossIconPosition(uploadedImageObject);
        });
    }
    
    if(shrinkMedia) {
        shrinkMedia.addEventListener('click', (event) => {
            canvasMediaControl(event);
            updateCrossIconPosition(uploadedImageObject);
        });
    }

    backingSelect.addEventListener('change', (e) => {
        backing = e.target.value;
        if (backing === 'smooth' || backing === 'gripper') {
            borderColorOptions.style.display = 'block';
        } else {
            borderColorOptions.style.display = 'none';
        }
        updatePreview();
    });

    document.querySelectorAll('input[name="color-swatch"]').forEach(swatch => {
        swatch.addEventListener('change', (e) => {
            boxColor = e.target.value;
            let selectedColorName = e.target.getAttribute('data-color-name');
            document.querySelector('.main-product__selected-color').textContent = selectedColorName;
            // borderColor = e.target.value; 
            updatePreview();
        });
    });

    text1Input.addEventListener('input', (e) => {
        text1 = e.target.value;
        updatePreview();
    });

    text2Input.addEventListener('input', (e) => {
        text2 = e.target.value;
        updatePreview();
    });

    fontFamily1Select.addEventListener('change', (e) => {
        font1.family = e.target.value;
        let ev = new Event('input');
        text1Input.dispatchEvent(ev);
    });

    fontSize1Input.addEventListener('input', (e) => {
        let newFontSize1 = e.target.value && !isNaN(e.target.value) ? parseInt(e.target.value) : 16;
        if (newFontSize1 < 12) { 
            newFontSize1 = 12; 
            fontSize1Input.value = 12; 
        }
        if (newFontSize1 > fontMaxsize) { 
            newFontSize1 = fontMaxsize; 
            fontSize1Input.value = fontMaxsize; 
        } 
        font1.size = newFontSize1;
        fontSize1Input.setAttribute('value',newFontSize1);
        if (text1Obj) {
            text1Obj.set({ fontSize: newFontSize1 });
            fbCanvas.requestRenderAll();
        }
    });

    if (fontcolor1Swatch) {
        fontcolor1Swatch.addEventListener('change', (e) => {
            font1.color = e.target.value;
            updatePreview();
        });
    }

    if (fontcolor2Swatch) {
        fontcolor2Swatch.addEventListener('change', (e) => {
            font2.color = e.target.value;
            updatePreview();
        });
    }

    fontFamily2Select.addEventListener('change', (e) => {
        font2.family = e.target.value;
        let ev = new Event('input');
        text2Input.dispatchEvent(ev);
    });

    fontSize2Input.addEventListener('input', (e) => {
        let newFontSize2 = e.target.value && !isNaN(e.target.value) ? parseInt(e.target.value) : 16;
        if (newFontSize2 < 12) { 
            newFontSize2 = 12; 
            fontSize2Input.value = 12; 
        }  
        if (newFontSize2 > fontMaxsize) { 
            newFontSize2 = fontMaxsize; 
            fontSize2Input.value = fontMaxsize; 
        }  
        font2.size = newFontSize2;
        fontSize2Input.setAttribute('value',newFontSize2);
        if (text2Obj) {
            text2Obj.set({ fontSize: newFontSize2 });
            fbCanvas.requestRenderAll();
        }
    });

    fieldsToTrack.forEach(selector => {
        const element = document.querySelector(selector);
        if (element) {
            element.addEventListener('change', () => {
                isFieldChanged = true;
            });
        }
    });

    document.querySelector('.font1-weight').addEventListener('click', () => {
        if (text1Obj) {
            font1.weight = (font1.weight === 'normal') ? 'bold' : 'normal';
            text1Obj.set({
                fontWeight: font1.weight
            });
            text1Obj.setCoords();
            fbCanvas.requestRenderAll();
            document.querySelector('.font1-weight').classList.toggle('is-active-button', font1.weight === 'bold');

            let ev = new Event('input');
            text1Input.dispatchEvent(ev);
        }
    });

    document.querySelector('.font1-style').addEventListener('click', () => {
        if (text1Obj) {
            font1.style = (font1.style === 'normal') ? 'italic' : 'normal';
            text1Obj.set({
                fontStyle: font1.style
            });
            text1Obj.setCoords();
            fbCanvas.requestRenderAll();
            document.querySelector('.font1-style').classList.toggle('is-active-button', font1.style === 'italic');

            let ev = new Event('input');
            text1Input.dispatchEvent(ev);
        }
    });

    document.querySelector('.font2-weight').addEventListener('click', () => {
        if (text2Obj) {
            font2.weight = (font2.weight === 'normal') ? 'bold' : 'normal';
            text2Obj.set({
                fontWeight: font2.weight
            });
            text2Obj.setCoords();
            fbCanvas.requestRenderAll();
            document.querySelector('.font2-weight').classList.toggle('is-active-button', font2.weight === 'bold');

            let ev = new Event('input');
            text2Input.dispatchEvent(ev);
        }
    });

    document.querySelector('.font2-style').addEventListener('click', () => {
        if (text2Obj) {
            font2.style = (font2.style === 'normal') ? 'italic' : 'normal';
            text2Obj.set({
                fontStyle: font2.style
            });
            text2Obj.setCoords();
            fbCanvas.requestRenderAll();
            document.querySelector('.font2-style').classList.toggle('is-active-button', font2.style === 'italic');

            let ev = new Event('input');
            text2Input.dispatchEvent(ev);
        }
    });

    let isConfirmed = false;
    let existingSelected;

    document.querySelectorAll('input[name="mateOrientation"]').forEach((element) => {
        if (element) {
            element.addEventListener('change', (e) => { 
                if (fbCanvas && isCanvasEnabled) {
                    if (isFieldChanged) {
                        e.preventDefault();
                        conformationModal = $.fancybox.open({
                            src: '#selection-reset-modal',
                            type: 'inline',
                            opts: {
                                click: false,
                                touch: false, 
                                afterShow: function () {
                                    isConfirmed = false;
                                },
                                afterClose: function () {
                                    if (isConfirmed) {
                                        fbCanvas.clear();
                                        canvasClear();
                                        fbCanvas.dispose();
                                        fbCanvas = null;
                                        isCanvasEnabled = false;
                                        setTimeout(handleOrientationChange, 100);
                                        isFieldChanged = false;
                                    } else {
                                        e.target.checked = false;
                                        existingSelected.checked = true;
                                        isFieldChanged = true;
                                    }
                                }
                            }
                        });
                    } else {
                        fbCanvas.clear();
                        canvasClear();
                        fbCanvas.dispose();
                        fbCanvas = null;
                        isCanvasEnabled = false;
                        setTimeout(handleOrientationChange, 100);
                        existingSelected = document.querySelector('input[name="mateOrientation"]:checked');
                    }
                } else {
                    handleOrientationChange();
                    existingSelected = document.querySelector('input[name="mateOrientation"]:checked');
                }

                let mediaBlock = document.querySelector(".customize-floor-mate-block__media");
                if(mediaBlock){
                    mediaBlock.classList.add("is-canvas-enable");
                }
            });
        }
    });

    $('#selection-reset-modal').on('click', 'button[data-fancybox-close]', function() {
        isConfirmed = false;
        conformationModal.close();
    });

    document.querySelector('.selection-reset-modal .js-selection-modal-close').addEventListener('click', function(e) {
        isConfirmed = false;
        conformationModal.close();
    });

    document.querySelector('.selection-reset-modal .js-selection-reset').addEventListener('click', function(e) {
        isConfirmed = true;
        conformationModal.close();
        existingSelected = document.querySelector('input[name="mateOrientation"]:checked');
        isFieldChanged =  false;
    });
    
    if ($('.main-product__customise-wrapper.is-accordion-enable').length > 0) {
        $('.main-product__customise-wrapper.is-accordion-enable').each(function() {
            let currentWrapper = $(this);
    
            currentWrapper.find('.main-product__select-heading').on('click', function() {
                let selectHeading = $(this);
                let selectBlock = selectHeading.closest('.main-product__customise-wrapper').find('.main-product__select-block');
                
                if (!selectBlock.hasClass('is-open-detail')) {
                    selectHeading.addClass('is-active-accordion');
                    selectBlock.addClass('is-open-detail').slideDown(350);
                } else {
                    selectHeading.removeClass('is-active-accordion');
                    selectBlock.removeClass('is-open-detail').slideUp(350);
                }
            });
        });
    }

    // Close all dropdowns and open the clicked one
    document.querySelectorAll('.color-swatch-dropdown__header').forEach(header => {
        header.addEventListener('click', function (event) {
            const dropdown = this.closest('.color-swatch-dropdown');
            const content = dropdown.querySelector('.color-swatch-dropdown__content');
            const header = dropdown.querySelector('.color-swatch-dropdown__header');

            document.querySelectorAll('.color-swatch-dropdown__content').forEach(otherContent => {
                if (otherContent !== content) {
                    otherContent.classList.remove('open');
                    otherContent.style.maxHeight = 0; 
                }
            });

            document.querySelectorAll('.color-swatch-dropdown__header').forEach(otherHeader => {
                if (otherHeader !== header) {
                    otherHeader.classList.remove('open');
                }
            });

            // Toggle the clicked dropdown's content
            content.classList.toggle('open');
            if (content.classList.contains('open')) {
                content.style.maxHeight = 450 + 'px';
            } else {
                content.style.maxHeight = 0;
            }
            header.classList.toggle('open');

            // Stop the event from propagating to the document click handler
            event.stopPropagation();
        });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function (event) {
        // Check if the click was outside any dropdown
        const isDropdownClick = event.target.closest('.color-swatch-dropdown');
        if (!isDropdownClick) {
            // Close all open dropdowns
            document.querySelectorAll('.color-swatch-dropdown__content').forEach(content => {
                content.classList.remove('open');
            });

            document.querySelectorAll('.color-swatch-dropdown__header').forEach(header => {
                header.classList.remove('open');
            });
        }
    });

    // Handle the "Show More" button toggle
    if(document.querySelectorAll('.color-swatch-dropdown__show-more').length > 0) {
        document.querySelectorAll('.color-swatch-dropdown__show-more').forEach(button => {
            button.addEventListener('click', function () {
                const dropdown = this.closest('.color-swatch-dropdown');
                const extraSwatches = dropdown.querySelectorAll('.color-swatch-dropdown__swatch-block.extra');
                const showMoreText = button.querySelector('.color-swatch-dropdown__show-more-text');

                const isExtraSwatchesVisible = extraSwatches[0]?.style.display === 'block'; 
        
                // Toggle extra swatches visibility
                extraSwatches.forEach(swatch => {
                    if (isExtraSwatchesVisible) {
                        swatch.style.display = 'none';
                        showMoreText.textContent = 'Show More';
                    } else {
                        swatch.style.display = 'block';
                        showMoreText.textContent = 'Show Less';
                    }
                });
        
                /*
                if (showMoreText.textContent === 'Show More') {
                    showMoreText.textContent = 'Show Less';
                } else {
                    showMoreText.textContent = 'Show More';
                }
                */
        
                const selectedRadio = dropdown.querySelector('.color-swatch-dropdown__swatch-input:checked');
                const selectedColor = selectedRadio ? selectedRadio.value : null;
                if (selectedColor) {
                    const checkedSwatch = dropdown.querySelector(`.color-swatch-dropdown__swatch-input[value="${selectedColor}"] + label`);
                    if (checkedSwatch) {
                        checkedSwatch.classList.add('active');
                    }
                }
            });
        });
    }

    // Handle color swatch selection for both mobile and desktop views font1
    document.querySelectorAll('.color-swatch-dropdown-font1 .color-swatch-dropdown__swatch-input').forEach(input => {
        input.addEventListener('change', function (event) {
            const selectedColor = this.value;
            const selectedId = this.id;

            let SelectColorName = this.getAttribute('data-color-name');

            font1.color = selectedColor;

            // Update the selected color in both desktop and mobile swatches
            updateSelectedSwatches1(selectedColor, selectedId, SelectColorName);

            updatePreview();
        });        
    });

    // Handle color swatch selection for both mobile and desktop views font2
    document.querySelectorAll('.color-swatch-dropdown-font2 .color-swatch-dropdown__swatch-input').forEach(input => {
          input.addEventListener('change', function () {
              const selectedColor = this.value;
              const selectedId = this.id;
              let SelectColorName = this.getAttribute('data-color-name');
  
              font2.color = selectedColor;
  
              // Update the selected color in both desktop and mobile swatches
              updateSelectedSwatches2(selectedColor, selectedId, SelectColorName);
  
              updatePreview();
          });
      });

    // Function to update selected swatches in both mobile and desktop views
    function updateSelectedSwatches1(color, id, colorName) {
        // Update desktop swatches
        const desktopSwatches1 = document.querySelectorAll('.color-swatch-dropdown-font1 .color-swatch-dropdown__swatch-input');
        desktopSwatches1.forEach(swatch => {
            const label = swatch.nextElementSibling;
            if ((swatch.value === color) && (swatch.id === id)) {
                swatch.checked = true;
                label.classList.add('active');
            } else {
                label.classList.remove('active');
            }
        });

        // Update mobile swatches
        const mobileSwatches1 = document.querySelectorAll('.color-swatch-dropdown-font1 .color-swatch-dropdown__swatch-input');
        mobileSwatches1.forEach(swatch => {
            const label = swatch.nextElementSibling;
            if ((swatch.value === color) && (swatch.id === id)) {
                swatch.checked = true;
                label.classList.add('active');
            } else {
                label.classList.remove('active');
            }
        });

        // Update the selected color in the dropdown header for both views
        const selectedHeader1 = document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__selected');
        selectedHeader1.querySelector('.color-swatch-dropdown__selected-color').style.backgroundColor = color;
        selectedHeader1.querySelector('.color-swatch-dropdown__selected-text').textContent = `${colorName} (${color})`;
    }

    function updateSelectedSwatches2(color, id, colorName) {
        // Update desktop swatches
        const desktopSwatches2 = document.querySelectorAll('.color-swatch-dropdown-font2 .color-swatch-dropdown__swatch-input');
        desktopSwatches2.forEach(swatch => {
            const label = swatch.nextElementSibling;
            if ((swatch.value === color) && (swatch.id === id)) {
                swatch.checked = true;
                label.classList.add('active');
            } else {
                label.classList.remove('active');
            }
        });

        const mobileSwatches2 = document.querySelectorAll('.color-swatch-dropdown-font2 .color-swatch-dropdown__swatch-input');
        mobileSwatches2.forEach(swatch => {
            const label = swatch.nextElementSibling;
            if ((swatch.value === color) && (swatch.id === id)) {
                swatch.checked = true;
                label.classList.add('active');
            } else {
                label.classList.remove('active');
            }
        });

        const selectedHeader2 = document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__selected');
        selectedHeader2.querySelector('.color-swatch-dropdown__selected-color').style.backgroundColor = color;
        selectedHeader2.querySelector('.color-swatch-dropdown__selected-text').textContent = `${colorName} (${color})`;;
    }

    // Set selected color on window load
    window.addEventListener('load', () => {
        document.querySelectorAll('.color-swatch-dropdown').forEach(dropdown => {
            const selectedRadio = dropdown.querySelector('.color-swatch-dropdown__swatch-input:checked');
            if (selectedRadio) {
                const selectedColor = selectedRadio.value;
                const selectedHeaderColor = dropdown.querySelector('.color-swatch-dropdown__selected-color');
                const selectedHeaderText = dropdown.querySelector('.color-swatch-dropdown__selected-text');

                // Set the selected color background and text on page load
                //selectedHeaderColor.style.backgroundColor = selectedColor;
                //selectedHeaderText.textContent = selectedColor;

                // Visually highlight the checked color swatch
                const checkedSwatch = dropdown.querySelector(`input[value="${selectedColor}"] + label`);
                if (checkedSwatch) {
                    checkedSwatch.classList.add('active');
                }
            }
        });
    });

    document.querySelector(".main-product__addMoreText").addEventListener('click', function (event) {
        event.preventDefault();
        
        const button = event.currentTarget;
        button.style.display = "none";
        
        const nextSibling = button.nextElementSibling;
        if (nextSibling && nextSibling.classList.contains('main-product__customise-text2')) {
            nextSibling.style.display = "block";
        }
    });

    function handleDetailBlockClick(event) {
        event.preventDefault();
        if (!(document.querySelector('input[name="mateOrientation"]:checked'))) {
            mustSelectOrientation(event);
        }
    }
    let detailBlockWrapper = document.querySelectorAll(".main-product__select-block.main-product__customise-overlay");
    if(detailBlockWrapper){
        detailBlockWrapper.forEach(function (detailBlock) {
            detailBlock.addEventListener("click", handleDetailBlockClick);
        });
    }

    function scrollToElement(element) {
        if (element) {
            // Get the position of the element relative to the document
            const elementPosition = element.getBoundingClientRect().bottom + window.pageYOffset;
    
            // Get the height of the viewport
            const viewportHeight = window.innerHeight;
    
            // Calculate the desired scroll position with the offset (100px from the bottom)
            const offsetPosition = elementPosition - viewportHeight + 100; // 100px above the bottom
    
            // Scroll smoothly to the calculated position
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    }

    function mustSelectOrientation(e) {
        let orientationErrorBlock = document.querySelector(".main-product__select-block > .error-message");
        if(orientationErrorBlock) {
            orientationErrorBlock.textContent = "Please can you select Orientation first";
            orientationErrorBlock.style.display = "block";
    
            let orientationOptionDiv = document.querySelector('.main-product__orientation-option');
    
            scrollToElement(orientationOptionDiv);
        }
        e.stopPropagation();
    }

    checkoutButton.addEventListener('click', function(e) {
        // debugger;
        // clear line item property
        //$('.save-data').attr('data-save', 'false')
          
        fbCanvas.discardActiveObject();
        fbCanvas.getObjects().forEach(function (obj) {
            obj.set('active', false);
        });
        fbCanvas.requestRenderAll();

        line_item_properties = {};

        let checkoutButtonErrorDiv = document.querySelector('.main-product__checkout .error-message');
        checkoutButtonErrorDiv.textContent = '';

        // custom size information
        let customSizeField = document.querySelector('.custom-width-input-field');
        let widthValue = document.querySelector('.custom-width-inner-elememt .custom-widht-grid input[name="width"]');
        let lengthValue = document.querySelector('.custom-width-inner-elememt .custom-widht-grid input[name="length"]');
        let customQtyInputBlock = document.querySelector('.main-product__select-block .custom-width-input-field--qty');
        let customQtyInput = document.querySelector('.main-product__select-block .custom-width-input-field--qty #fourplusqty');

        if (widthValue) {
            widthValue.nextElementSibling.style.display = "none";
            widthValue.nextElementSibling.textContent = "";
        }
        if (lengthValue) {
            lengthValue.nextElementSibling.style.display = "none";
            lengthValue.nextElementSibling.textContent = "";
        }

        if (customQtyInput.nextElementSibling) {
            customQtyInput.nextElementSibling.style.display = "none"
            customQtyInput.nextElementSibling.textContent = "";
        }

        if (uploadLogoInput.nextElementSibling) {
            uploadLogoInput.nextElementSibling.style.display = "block";
            uploadLogoInput.nextElementSibling.textContent = "";
        }

        if (!(document.querySelector('input[name="mateOrientation"]:checked'))) {
            mustSelectOrientation(e);
            return;
        }

        if (customSizeField && window.getComputedStyle(customSizeField).display !== 'none' && window.getComputedStyle(customSizeField).visibility !== 'hidden' && customSizeField.offsetWidth > 0 && customSizeField.offsetHeight > 0) {
            if (widthValue.value === "" && lengthValue.value === "") {
                widthValue.nextElementSibling.style.display = "block";
                widthValue.nextElementSibling.textContent = "Please can you Enter width in (cm)";
                lengthValue.nextElementSibling.style.display = "block";
                lengthValue.nextElementSibling.textContent = "Please can you Enter Length in (cm)";

                scrollToElement(widthValue);
                return;
            }

            if (widthValue.value === "") {
                widthValue.nextElementSibling.style.display = "block";
                widthValue.nextElementSibling.textContent = "Please can you Enter width in (cm)";
                scrollToElement(widthValue);
                return;
            } else if (widthValue.value <= 49) {
                widthValue.nextElementSibling.style.display = "block";
                widthValue.nextElementSibling.textContent = "Please Enter width more than 50cm";
                scrollToElement(widthValue);
                return;
            } else if (widthValue.value >= 551) {
                widthValue.nextElementSibling.style.display = "block";
                widthValue.nextElementSibling.textContent = "Please Enter width less than 550cm";
                scrollToElement(widthValue);
                return;
            }

            if (lengthValue.value === "") {
                lengthValue.nextElementSibling.style.display = "block";
                lengthValue.nextElementSibling.textContent = "Please can you Enter Length in (cm)";
                scrollToElement(lengthValue);
                return;
            } else if (lengthValue.value <= 49) {
                lengthValue.nextElementSibling.style.display = "block";
                lengthValue.nextElementSibling.textContent = "Please Enter Length more than 50cm";
                scrollToElement(lengthValue);
                return;
            } else if (lengthValue.value >= 551) {
                lengthValue.nextElementSibling.style.display = "block";
                lengthValue.nextElementSibling.textContent = "Please Enter Length less than 550cm";
                scrollToElement(lengthValue);
                return;
            }
        } else {
            if (widthValue) {
                widthValue.nextElementSibling.style.display = "none";
                widthValue.nextElementSibling.textContent = "";
            }

            if (lengthValue) {
                lengthValue.nextElementSibling.style.display = "none";
                lengthValue.nextElementSibling.textContent = "";
            }
        }

        if (customQtyInputBlock && 
                window.getComputedStyle(customQtyInputBlock).display !== 'none' 
                    && window.getComputedStyle(customQtyInputBlock).visibility !== 'hidden' 
                        && customQtyInputBlock.offsetWidth > 0 
                            && customQtyInputBlock.offsetHeight > 0) {
            let errorMessage = customQtyInput.nextElementSibling && customQtyInput.nextElementSibling.classList.contains("qty-error-message");
            let errorDiv;
            if (customQtyInput.value === "" || customQtyInput.value <= 3) {
                if (!errorMessage) {
                    errorDiv = document.createElement('div');
                    errorDiv.classList.add('qty-error-message');
                    errorDiv.style.color = "red";

                    customQtyInput.parentNode.insertBefore(errorDiv, customQtyInput.nextSibling);
                }
                if (customQtyInput.value === "") {
                    customQtyInput.nextElementSibling.textContent = "Please enter a quantity.";
                } else if (customQtyInput.value <= 3) {
                    customQtyInput.nextElementSibling.textContent = "Please enter a quantity more than 3";
                }

                customQtyInput.nextElementSibling.style.display = "block";
                scrollToElement(customQtyInput);
                return;

            } else {
                if(errorMessage){
                    customQtyInput.nextElementSibling.style.display = "none"
                    customQtyInput.nextElementSibling.textContent = "";
                }
            }
        }

        if (uploadLogoInput.files.length === 0 || !uploadLogoInput.files[0].name) {
            showErrorMessage(uploadLogoInput, 'Must add Image field');
            uploadLogoInput.nextElementSibling.style.display = "block";

            scrollToElement(uploadLogoInput);
            return;
        }
        
        orientationInputs.forEach(function(input) {
            if (input.checked) {
                // Add the checked value to line_item_properties object
                line_item_properties.Orientation = input.value;
            }
        });

        let selectedVariantID = Number(this.getAttribute('data-variant-id'));
        let currentQty = Number(document.querySelector('.main-product__quantity-option .cw-product-bundle__variant-selected').getAttribute('currentqty'));

        
        if($('.main-product__size-option [name="selectedValue"]').val().toUpperCase().indexOf('CUSTOM') != -1) {
            var customprice = Number($(`.cw-product-bundle__variant-option[data-text='${$('.main-product__size-option .cw-product-bundle__variant-text').text()}']`).attr("data-variant-price"));
            var origanl_price = Number($(`.cw-product-bundle__variant-option[data-text='${$('.main-product__size-option .cw-product-bundle__variant-text').text()}']`).attr("data-orignal_price"));
            currentQty = Math.ceil(customprice / origanl_price);
        }

        setTimeout(() => {
            fbCanvas.toDataURL();
          
            async function uploadBase64Image(base64Image) {
                
                // Prepare the JSON payload
                const payload = JSON.stringify({ image: base64Image });
               
                try {   
                    const response = await fetch('https://www.firstmatsproofs.co.uk/firstmatsproofs.co.uk/eq-product-customizer/canvaspreview.php', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json', // Set content type to JSON
                        },
                        body: payload,
                    });
            
                    if (response.ok) {
                        const result = await response.json();
            
                        if (result.fileUrl) {
                            console.log('this is new file  ' + result.fileUrl)
                            line_item_properties[`Preview Image`] = result.fileUrl;
                            
                            // Add other properties (assuming they are defined elsewhere in your code)
                            let selectedSize = document.querySelector('.main-product__size-option .cw-product-bundle__variant-selected .cw-product-bundle__variant-text').textContent;
                            let selectedQty = document.querySelector('.main-product__quantity-option .cw-product-bundle__variant-selected .cw-product-bundle__variant-text').textContent;
                            let selectedMatColor = document.querySelector('.main-product__select-block .main-product__color-option .main-product__color-swatch input:checked').getAttribute('data-color-name');
                            let uploadedLogoImage = document.querySelector('#floor-mat-image-from-outside').getAttribute('src');
                    
                            // Text 1
                            let text1Value = document.querySelector('input#text1').value;
                            let text1FontFamily = document.querySelector('#font-family1 option:checked');
                            let text1FontFamilyName = text1FontFamily ? text1FontFamily.value : null;
                            let text1FontSize = document.querySelector('input#font-size1').getAttribute('value');
                            let text1FontStyle = document.querySelector('.font-style-customize button.font1-style');
                            text1FontStyle = text1FontStyle.classList.contains('is-active-button') ? 'italic' : 'normal';
                    
                            let text1FontWeight = document.querySelector('.font-weight-customize button.font1-weight');
                            text1FontWeight = text1FontWeight.classList.contains('is-active-button') ? 'bold' : 'normal';
                    
                            let text1ColorName; 
                            let text1ColorHexCode; 

                            if(window.innerWidth >= 768) {
                                text1ColorName = document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__list-desktop input:checked').getAttribute('data-color-name');
                                text1ColorHexCode = document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__list-desktop input:checked').getAttribute('value');
                            } else {
                                text1ColorName = document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__list-mobile input:checked').getAttribute('data-color-name');
                                text1ColorHexCode = document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__list-mobile input:checked').getAttribute('value');
                            }

                            
                    
                            if (text1Value) {
                                line_item_properties[`Text 1`] = text1Value;
                                line_item_properties[`Text 1 Font-Family`] = text1FontFamilyName;
                                line_item_properties[`Text 1 Font-Size`] = text1FontSize;
                                line_item_properties[`Text 1 Font-Style`] = text1FontStyle;
                                line_item_properties[`Text 1 Font-Weight`] = text1FontWeight;
                                line_item_properties[`Text 1 Color`] = `${text1ColorName} (${text1ColorHexCode})`; 
                            }
                    
                            if (customSizeField && window.getComputedStyle(customSizeField).display !== 'none' && window.getComputedStyle(customSizeField).visibility !== 'hidden' && customSizeField.offsetWidth > 0 && customSizeField.offsetHeight > 0) {}
                                if (widthValue && widthValue.value > 0) {
                                    let customWidth = Number(widthValue.value);
                                    line_item_properties[`Custom Width`] = `${customWidth}`;
                                }else{
                                    line_item_properties.Size = selectedSize;
                                }
                            
                    
                            if (customSizeField && window.getComputedStyle(customSizeField).display !== 'none' && window.getComputedStyle(customSizeField).visibility !== 'hidden' && customSizeField.offsetWidth > 0 && customSizeField.offsetHeight > 0) {  }
                                if (lengthValue && lengthValue.value > 0) {
                                    let customLength = Number(lengthValue.value);
                                    line_item_properties[`Custom Length`] = `${customLength}`;
                                }else{
                                    line_item_properties.Size = selectedSize;
                                }
                          
                    

                            if (customQtyInputBlock && window.getComputedStyle(customQtyInputBlock).display !== 'none' && window.getComputedStyle(customQtyInputBlock).visibility !== 'hidden' && customQtyInputBlock.offsetWidth > 0 && customQtyInputBlock.offsetHeight > 0) {
                                if (lengthValue && lengthValue.value > 0) {
                                    let customLength = Number(lengthValue.value);
                                    line_item_properties[`Custom Size Length`] = `${customLength}`;
                                }
                            }
                    
                            // Text 2
                            let text2Value = document.querySelector('input#text2').value;
                            let text2FontFamilyName = document.querySelector('#font-family2 option:checked').value;
                            let text2FontSize = document.querySelector('input#font-size2').getAttribute('value');
                            let text2FontStyle = document.querySelector('.font-style-customize button.font2-style');
                            text2FontStyle = text2FontStyle.classList.contains('is-active-button') ? 'italic' : 'normal';
                    
                            let text2FontWeight = document.querySelector('.font-weight-customize button.font2-weight');
                            text2FontWeight = text2FontWeight.classList.contains('is-active-button') ? 'bold' : 'normal';
                    
                            let text2ColorName; 
                            let text2ColorHexCode; 

                            if(window.innerWidth >= 768) {
                                text2ColorName = document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__list-desktop input:checked').getAttribute('data-color-name');
                                text2ColorHexCode = document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__list-desktop input:checked').getAttribute('value');
                            } else {
                                text2ColorName = document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__list-mobile input:checked').getAttribute('data-color-name');
                                text2ColorHexCode = document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__list-mobile input:checked').getAttribute('value');
                            }
                    
                            if (text2Value) {
                                line_item_properties[`Text 2`] = text2Value;
                                line_item_properties[`Text 2 Font-Family`] = text2FontFamilyName;
                                line_item_properties[`Text 2 Font-Size`] = text2FontSize;
                                line_item_properties[`Text 2 Font-Style`] = text2FontStyle;
                                line_item_properties[`Text 2 Font-Weight`] = text2FontWeight;
                                line_item_properties[`Text 2 Color`] = `${text2ColorName} (${text2ColorHexCode})`;
                            }
                    
                            // Adding other properties to line_item_properties
                            // line_item_properties.Size = selectedSize;
                            line_item_properties.Qty = selectedQty;
                            line_item_properties[`Mat Background Color`] = selectedMatColor;
                            line_item_properties[`Uploaded Logo`] = uploadedLogoImage;
                    
                            // Call addToCart with updated line_item_properties
                            if($('.save-data').attr('data-save') == 'true'){
                                
                            }else{
                            addToCart(selectedVariantID, currentQty, line_item_properties);
                            }
                            $(".secure-checkout__field input").each(function () {
                                let secureCheckoutInput = $(this);
                                if (secureCheckoutInput.val().trim() !== "") {
                                  secureCheckoutInput.removeClass("invalid");
                                  secureCheckoutInput.siblings(".error-message").hide();
                                }
                              });
                              
                              let orientation_value = $(
                                'input[name="mateOrientation"]:checked'
                              ).val();
                              let customWidth = $('input[name="width"]').val();
                              let customLength = $('input[name="length"]').val();
                              let selected_size_value = $(".main-product__size-option")
                                .find(
                                  ".cw-product-bundle__variant-selected .cw-product-bundle__variant-text"
                                )
                                .html();
                              let selected_product_price_value = $(".main-product__size-option")
                                .find(
                                  ".cw-product-bundle__variant-selected .cw-product-bundle__variant-price"
                                )
                                .html();
                              let productVarPrice = $(".main-product__size-option").find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price").attr('data-without-money-total');
                             
                              let selected_product_quantity_value = $(".main-product__quantity-option")
                                .find(".cw-product-bundle__variant-selected")
                                .attr("currentqty");
                              let totalPrice = productVarPrice * selected_product_quantity_value;
                              let discount_percentage_value = $(".main-product__quantity-option")
                                .find(
                                  ".cw-product-bundle__variant-selected .cw-product-bundle__variant-save-percentage"
                                )
                                .html();
                              let total_price_value = $(".main-product__quantity-option")
                                .find(
                                  ".cw-product-bundle__variant-selected .cw-product-bundle__variant-price"
                                )
                                .html();
                              let selected_color_value = $(".main-product__color-option")
                                .find('input[name="color-swatch"]:checked')
                                .val();
                                
                            
                              const selectedOptions = $(".product-set-variant").find(
                                "input[type=radio]:checked"
                              );
                          
                              // console.log(selectedOptionValues)
                              // console.log('variantData ',variantData)
                           
                              const imgElement = $(".main-product__upload-preview img");
                        
                              // let customer_firstname = $("#secure-checkout").find("#firstName").val();
                              // let customer_surname = $("#secure-checkout").find("#surname").val();
                              // let customer_email = $("#secure-checkout").find("#email").val();
                              let customerData = {}; // Initialize the customerData object
                              let customerData2 = {};
                              let queryparameters; // Declare queryparameters outside the if block to make it accessible globally
                        
                              let currentUrl = window.location.href;
                              
                              // Check if the URL contains a query string
                              if (currentUrl.includes("?")) {
                                // Extract query string after '?'
                                queryparameters = currentUrl.split("?")[1];
                                console.log("queryparameters:", queryparameters);
                                sessionStorage.setItem("queryparameters", queryparameters);
                        
                                // Parse query parameters into individual key-value pairs and add them to customerData
                                queryparameters.split("&").forEach((param) => {
                                  const [key, value] = param.split("=");
                                  // Directly add each key-value pair to customerData
                                  customerData[key] = decodeURIComponent(value || ""); // Handle URL encoding
                                });
                        
                                console.log("Updated customerData:", customerData);
                              }
                        
                             
                              
                             
                              customerData["Orientation"] = orientation_value;
                              if (customWidth !== '') {
                                customerData["Custom Width"] = customWidth;
                                customerData["Custom Length"] = customLength;
                              } else {
                                customerData["Size"] = selected_size_value;
                              }
                              
                          //  alert('updated')
                              const selectedOptionValuess = [];
                              selectedOptions.map((i, elm) => {
                                selectedOptionValuess.push($(elm).val());
                              });
                        
                              
                              const variantData = JSON.parse($(".data-variant-selector").text());
                              
                              const currentVariant = variantData.find((variant) =>
                                variant.options.every(
                                  (value, index) => value === selectedOptionValuess[index]
                                )
                              );
                              customerData["Product Price"] = selected_product_price_value;
                              customerData["Quantity"] = selected_product_quantity_value;
                              customerData["Discount percentage"] = discount_percentage_value;
                             if (customWidth !== '') {
                               customerData["Total Price"] = $(".main-product__size-option").find(".cw-product-bundle__variant-selected .cw-product-bundle__variant-price").attr('data-without-money-total');;
                             }else{
                                customerData["Total Price"] = Shopify.formatMoney(totalPrice);
                             }
                             
                              customerData["Product Variant Id"] = currentVariant.id;
                              if (imgElement.length > 0) {
                                const imageUrl = imgElement.attr("src");
                                customerData["Image URL"] = imageUrl;
                              } 
                              customerData["Image URL"] = result.fileUrl;
                              customerData["Firstname"] = $('input[name="firstname"]').val();
                              customerData["Surname"] = $('input[name="lastname"]').val();
                              customerData["Email"] = $('input[name="email"]').val();
                              customerData["Color hex code"] = selected_color_value;
                              customerData["Color name"] = $('input[name="color-swatch"]:checked').attr('data-color-name');
                              
                              if($('.save-data').attr('data-save') == 'true'){
                               
                                
                            $.ajax({
                                    url: "https://978c0db17126e0df9814e33c45eb3d.ac.environment.api.powerplatform.com:443/powerautomate/automations/direct/workflows/a1db15ac68cd42ecb0e3c5836423975b/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=io575_RW5AF3ABdY7CyXRG0nxcwOxKjZqwSCuFWHoTc",
                                    method: "POST",
                                    contentType: "application/json; charset=utf-8",
                                    data: JSON.stringify(customerData),
                                    success: function(data) {
                                        $(".secure-checkout__form").addClass("form-submit-success");
                                        $('.save-data').text('Save Design');
                                        $('.save-data').css('pointer-evetns', 'all');
                                        Fancybox.show([{
                                            src: '#popup_success_msg',
                                            type: 'inline',
                                            hideScrollbar: false
                                            }], {
                                            click: false, // disable closing on outside click
                                            trapFocus: true,
                                            backdropClick: false, // optional, also helps in some cases
                                            on: {
                                                destroy: () => {
                                                window.location.reload();
                                                }
                                            }
                                            });
                                    },
                                    error: function(data) {
                                        console.log('add class body')
                                        console.log("error ", data);
                                        if ($(".secure-checkout__form").hasClass("form-submit-success")) {
                                            $(".secure-checkout__form").removeClass("form-submit-success");
                                        }
                                    },
                                });
                                $('.save-data').attr('data-save', 'fasle');
                              }else{
                                $.ajax({
                                    url: "https://firstmatsproofs.co.uk/firstmatsproofs.co.uk/eq-pdp-image/postdata.php",
                                    method: "POST",
                                    dataType: "JSON",
                                    contentType: "application/json; charset=utf-8",
                                    data: JSON.stringify(customerData),
                                    success: function (data) {
                                      console.log("submittted form data", customerData);
                                      //alert('data submited');
                                      $(".secure-checkout__form").addClass("form-submit-success");
                                    },
                                    error: function (data) {
                                      // console.log("error ", data);
                                      if ($(".secure-checkout__form").hasClass("form-submit-success")) {
                                        $(".secure-checkout__form").removeClass("form-submit-success");
                                      }
                                    },
                                  });
                              }  
                   


                        } else {
                            checkoutButtonErrorDiv.textContent = 'Failed to retrieve the image URL.';
                        }
                    } else {
                        checkoutButtonErrorDiv.textContent = 'File upload failed';
                    }
                } catch (error) {
                    console.error('Error:', error);
                }
            }
            uploadBase64Image(canvas.toDataURL());
        

        }, 50);
       
    });


    // checkoutButton.addEventListener('click', function(e) {
    //     // debugger;
    //     // clear line item property
        
    //     fbCanvas.discardActiveObject();
    //     fbCanvas.getObjects().forEach(function (obj) {
    //         obj.set('active', false);
    //     });
    //     fbCanvas.requestRenderAll();

    //     line_item_properties = {};

    //     let checkoutButtonErrorDiv = document.querySelector('.main-product__checkout .error-message');
    //     checkoutButtonErrorDiv.textContent = '';

    //     // custom size information
    //     let customSizeField = document.querySelector('.custom-width-input-field');
    //     let widthValue = document.querySelector('.custom-width-inner-elememt .custom-widht-grid input[name="width"]');
    //     let lengthValue = document.querySelector('.custom-width-inner-elememt .custom-widht-grid input[name="length"]');
    //     let customQtyInputBlock = document.querySelector('.main-product__select-block .custom-width-input-field--qty');
    //     let customQtyInput = document.querySelector('.main-product__select-block .custom-width-input-field--qty #fourplusqty');

    //     if (widthValue) {
    //         widthValue.nextElementSibling.style.display = "none";
    //         widthValue.nextElementSibling.textContent = "";
    //     }
    //     if (lengthValue) {
    //         lengthValue.nextElementSibling.style.display = "none";
    //         lengthValue.nextElementSibling.textContent = "";
    //     }

    //     if (customQtyInput.nextElementSibling) {
    //         customQtyInput.nextElementSibling.style.display = "none"
    //         customQtyInput.nextElementSibling.textContent = "";
    //     }

    //     if (uploadLogoInput.nextElementSibling) {
    //         uploadLogoInput.nextElementSibling.style.display = "block";
    //         uploadLogoInput.nextElementSibling.textContent = "";
    //     }

    //     if (!(document.querySelector('input[name="mateOrientation"]:checked'))) {
    //         mustSelectOrientation(e);
    //         return;
    //     }

    //     if (customSizeField && window.getComputedStyle(customSizeField).display !== 'none' && window.getComputedStyle(customSizeField).visibility !== 'hidden' && customSizeField.offsetWidth > 0 && customSizeField.offsetHeight > 0) {
    //         if (widthValue.value === "" && lengthValue.value === "") {
    //             widthValue.nextElementSibling.style.display = "block";
    //             widthValue.nextElementSibling.textContent = "Please can you Enter width in (cm)";
    //             lengthValue.nextElementSibling.style.display = "block";
    //             lengthValue.nextElementSibling.textContent = "Please can you Enter Length in (cm)";

    //             scrollToElement(widthValue);
    //             return;
    //         }

    //         if (widthValue.value === "") {
    //             widthValue.nextElementSibling.style.display = "block";
    //             widthValue.nextElementSibling.textContent = "Please can you Enter width in (cm)";
    //             scrollToElement(widthValue);
    //             return;
    //         } else if (widthValue.value <= 49) {
    //             widthValue.nextElementSibling.style.display = "block";
    //             widthValue.nextElementSibling.textContent = "Please Enter width more than 50cm";
    //             scrollToElement(widthValue);
    //             return;
    //         } else if (widthValue.value >= 551) {
    //             widthValue.nextElementSibling.style.display = "block";
    //             widthValue.nextElementSibling.textContent = "Please Enter width less than 550cm";
    //             scrollToElement(widthValue);
    //             return;
    //         }

    //         if (lengthValue.value === "") {
    //             lengthValue.nextElementSibling.style.display = "block";
    //             lengthValue.nextElementSibling.textContent = "Please can you Enter Length in (cm)";
    //             scrollToElement(lengthValue);
    //             return;
    //         } else if (lengthValue.value <= 49) {
    //             lengthValue.nextElementSibling.style.display = "block";
    //             lengthValue.nextElementSibling.textContent = "Please Enter Length more than 50cm";
    //             scrollToElement(lengthValue);
    //             return;
    //         } else if (lengthValue.value >= 551) {
    //             lengthValue.nextElementSibling.style.display = "block";
    //             lengthValue.nextElementSibling.textContent = "Please Enter Length less than 550cm";
    //             scrollToElement(lengthValue);
    //             return;
    //         }
    //     } else {
    //         if (widthValue) {
    //             widthValue.nextElementSibling.style.display = "none";
    //             widthValue.nextElementSibling.textContent = "";
    //         }

    //         if (lengthValue) {
    //             lengthValue.nextElementSibling.style.display = "none";
    //             lengthValue.nextElementSibling.textContent = "";
    //         }
    //     }

    //     if (customQtyInputBlock && 
    //             window.getComputedStyle(customQtyInputBlock).display !== 'none' 
    //                 && window.getComputedStyle(customQtyInputBlock).visibility !== 'hidden' 
    //                     && customQtyInputBlock.offsetWidth > 0 
    //                         && customQtyInputBlock.offsetHeight > 0) {
    //         let errorMessage = customQtyInput.nextElementSibling && customQtyInput.nextElementSibling.classList.contains("qty-error-message");
    //         let errorDiv;
    //         if (customQtyInput.value === "" || customQtyInput.value <= 3) {
    //             if (!errorMessage) {
    //                 errorDiv = document.createElement('div');
    //                 errorDiv.classList.add('qty-error-message');
    //                 errorDiv.style.color = "red";

    //                 customQtyInput.parentNode.insertBefore(errorDiv, customQtyInput.nextSibling);
    //             }
    //             if (customQtyInput.value === "") {
    //                 customQtyInput.nextElementSibling.textContent = "Please enter a quantity.";
    //             } else if (customQtyInput.value <= 3) {
    //                 customQtyInput.nextElementSibling.textContent = "Please enter a quantity more than 3";
    //             }

    //             customQtyInput.nextElementSibling.style.display = "block";
    //             scrollToElement(customQtyInput);
    //             return;

    //         } else {
    //             if(errorMessage){
    //                 customQtyInput.nextElementSibling.style.display = "none"
    //                 customQtyInput.nextElementSibling.textContent = "";
    //             }
    //         }
    //     }

    //     if (uploadLogoInput.files.length === 0 || !uploadLogoInput.files[0].name) {
    //         showErrorMessage(uploadLogoInput, 'Must add Image field');
    //         uploadLogoInput.nextElementSibling.style.display = "block";

    //         scrollToElement(uploadLogoInput);
    //         return;
    //     }
        
    //     orientationInputs.forEach(function(input) {
    //         if (input.checked) {
    //             // Add the checked value to line_item_properties object
    //             line_item_properties.Orientation = input.value;
    //         }
    //     });

    //     let selectedVariantID = Number(this.getAttribute('data-variant-id'));
    //     let currentQty = Number(document.querySelector('.main-product__quantity-option .cw-product-bundle__variant-selected').getAttribute('currentqty'));

        
    //     if($('.main-product__size-option [name="selectedValue"]').val().toUpperCase().indexOf('CUSTOM') != -1) {
    //         var customprice = Number($(`.cw-product-bundle__variant-option[data-text='${$('.main-product__size-option .cw-product-bundle__variant-text').text()}']`).attr("data-variant-price"));
    //         var origanl_price = Number($(`.cw-product-bundle__variant-option[data-text='${$('.main-product__size-option .cw-product-bundle__variant-text').text()}']`).attr("data-orignal_price"));
    //         currentQty = Math.ceil(customprice / origanl_price);
    //     }

    //     setTimeout(() => {
    //         fbCanvas.toDataURL();

    //         async function uploadBase64Image(base64Image) {
            
    //             // Prepare the JSON payload
    //             const payload = JSON.stringify({ image: base64Image });
    //             console.log(payload)
    //             try {   
    //                 const response = await fetch('https://www.firstmatsproofs.co.uk/firstmatsproofs.co.uk/eq-product-customizer/canvaspreview.php', {
    //                     method: 'POST',
    //                     headers: {
    //                         'Content-Type': 'application/json', // Set content type to JSON
    //                     },
    //                     body: payload,
    //                 });
            
    //                 if (response.ok) {
    //                     const result = await response.json();
            
    //                     if (result.fileUrl) {
    //                         console.log('this is new file  ' + result.fileUrl)
    //                         line_item_properties[`Preview Image`] = result.fileUrl;
                            
    //                         // Add other properties (assuming they are defined elsewhere in your code)
    //                         let selectedSize = document.querySelector('.main-product__size-option .cw-product-bundle__variant-selected .cw-product-bundle__variant-text').textContent;
    //                         let selectedQty = document.querySelector('.main-product__quantity-option .cw-product-bundle__variant-selected .cw-product-bundle__variant-text').textContent;
    //                         let selectedMatColor = document.querySelector('.main-product__select-block .main-product__color-option .main-product__color-swatch input:checked').getAttribute('data-color-name');
    //                         let uploadedLogoImage = document.querySelector('#floor-mat-image-from-outside').getAttribute('src');
                    
    //                         // Text 1
    //                         let text1Value = document.querySelector('input#text1').value;
    //                         let text1FontFamily = document.querySelector('#font-family1 option:checked');
    //                         let text1FontFamilyName = text1FontFamily ? text1FontFamily.value : null;
    //                         let text1FontSize = document.querySelector('input#font-size1').getAttribute('value');
    //                         let text1FontStyle = document.querySelector('.font-style-customize button.font1-style');
    //                         text1FontStyle = text1FontStyle.classList.contains('is-active-button') ? 'italic' : 'normal';
                    
    //                         let text1FontWeight = document.querySelector('.font-weight-customize button.font1-weight');
    //                         text1FontWeight = text1FontWeight.classList.contains('is-active-button') ? 'bold' : 'normal';
                    
    //                         let text1ColorName; 
    //                         let text1ColorHexCode; 

    //                         if(window.innerWidth >= 768) {
    //                             text1ColorName = document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__list-desktop input:checked').getAttribute('data-color-name');
    //                             text1ColorHexCode = document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__list-desktop input:checked').getAttribute('value');
    //                         } else {
    //                             text1ColorName = document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__list-mobile input:checked').getAttribute('data-color-name');
    //                             text1ColorHexCode = document.querySelector('.color-swatch-dropdown-font1 .color-swatch-dropdown__list-mobile input:checked').getAttribute('value');
    //                         }

                            
                    
    //                         if (text1Value) {
    //                             line_item_properties[`Text 1`] = text1Value;
    //                             line_item_properties[`Text 1 Font-Family`] = text1FontFamilyName;
    //                             line_item_properties[`Text 1 Font-Size`] = text1FontSize;
    //                             line_item_properties[`Text 1 Font-Style`] = text1FontStyle;
    //                             line_item_properties[`Text 1 Font-Weight`] = text1FontWeight;
    //                             line_item_properties[`Text 1 Color`] = `${text1ColorName} (${text1ColorHexCode})`; 
    //                         }
                    
    //                         if (customSizeField && window.getComputedStyle(customSizeField).display !== 'none' && window.getComputedStyle(customSizeField).visibility !== 'hidden' && customSizeField.offsetWidth > 0 && customSizeField.offsetHeight > 0) {
    //                             if (widthValue && widthValue.value > 0) {
    //                                 let customWidth = Number(widthValue.value);
    //                                 line_item_properties[`Custom Size Width`] = `${customWidth}`;
    //                             }
    //                         }
                    
    //                         if (customSizeField && window.getComputedStyle(customSizeField).display !== 'none' && window.getComputedStyle(customSizeField).visibility !== 'hidden' && customSizeField.offsetWidth > 0 && customSizeField.offsetHeight > 0) {
    //                             if (lengthValue && lengthValue.value > 0) {
    //                                 let customLength = Number(lengthValue.value);
    //                                 line_item_properties[`Custom Size Length`] = `${customLength}`;
    //                             }
    //                         }
                    

    //                         if (customQtyInputBlock && window.getComputedStyle(customQtyInputBlock).display !== 'none' && window.getComputedStyle(customQtyInputBlock).visibility !== 'hidden' && customQtyInputBlock.offsetWidth > 0 && customQtyInputBlock.offsetHeight > 0) {
    //                             if (lengthValue && lengthValue.value > 0) {
    //                                 let customLength = Number(lengthValue.value);
    //                                 line_item_properties[`Custom Size Length`] = `${customLength}`;
    //                             }
    //                         }
                    
    //                         // Text 2
    //                         let text2Value = document.querySelector('input#text2').value;
    //                         let text2FontFamilyName = document.querySelector('#font-family2 option:checked').value;
    //                         let text2FontSize = document.querySelector('input#font-size2').getAttribute('value');
    //                         let text2FontStyle = document.querySelector('.font-style-customize button.font2-style');
    //                         text2FontStyle = text2FontStyle.classList.contains('is-active-button') ? 'italic' : 'normal';
                    
    //                         let text2FontWeight = document.querySelector('.font-weight-customize button.font2-weight');
    //                         text2FontWeight = text2FontWeight.classList.contains('is-active-button') ? 'bold' : 'normal';
                    
    //                         let text2ColorName; 
    //                         let text2ColorHexCode; 

    //                         if(window.innerWidth >= 768) {
    //                             text2ColorName = document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__list-desktop input:checked').getAttribute('data-color-name');
    //                             text2ColorHexCode = document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__list-desktop input:checked').getAttribute('value');
    //                         } else {
    //                             text2ColorName = document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__list-mobile input:checked').getAttribute('data-color-name');
    //                             text2ColorHexCode = document.querySelector('.color-swatch-dropdown-font2 .color-swatch-dropdown__list-mobile input:checked').getAttribute('value');
    //                         }
                    
    //                         if (text2Value) {
    //                             line_item_properties[`Text 2`] = text2Value;
    //                             line_item_properties[`Text 2 Font-Family`] = text2FontFamilyName;
    //                             line_item_properties[`Text 2 Font-Size`] = text2FontSize;
    //                             line_item_properties[`Text 2 Font-Style`] = text2FontStyle;
    //                             line_item_properties[`Text 2 Font-Weight`] = text2FontWeight;
    //                             line_item_properties[`Text 2 Color`] = `${text2ColorName} (${text2ColorHexCode})`;
    //                         }
                    
    //                         // Adding other properties to line_item_properties
    //                         line_item_properties.Size = selectedSize;
    //                         line_item_properties.Qty = selectedQty;
    //                         line_item_properties[`Mat Background Color`] = selectedMatColor;
    //                         line_item_properties[`Uploaded Logo`] = uploadedLogoImage;
                    
    //                         // Call addToCart with updated line_item_properties
    //                         addToCart(selectedVariantID, currentQty, line_item_properties);
        
    //                     } else {
    //                         checkoutButtonErrorDiv.textContent = 'Failed to retrieve the image URL.';
    //                     }
    //                 } else {
    //                     checkoutButtonErrorDiv.textContent = 'File upload failed';
    //                 }
    //             } catch (error) {
    //                 console.error('Error:', error);
    //             }
    //         }
    //         uploadBase64Image(canvas.toDataURL());
    //     }, 50);
    // });
    
    function addToCart(id, qty, properties) {
        let formData = {
            'items': [{
             'id': id,
             'quantity': qty,
             "properties": properties
             }]
           };
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            addToCartAndOpenDrawer();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
    }
    
    const { ColorMatrix, Brightness, Contrast, Saturation } = fabric.filters;

    function applyFiltersWithColorMatrix(tintMatrix, brightnessValue, contrastValue, saturationValue) {
        if (uploadedImageObject && uploadedImageObject !== null) {

            uploadedImageObject.filters = [];

            uploadedImageObject.filters.push(new ColorMatrix({ matrix: tintMatrix }));
            uploadedImageObject.filters.push(new Brightness({ brightness: brightnessValue }));
            uploadedImageObject.filters.push(new Contrast({ contrast: contrastValue }));
            uploadedImageObject.filters.push(new Saturation({ saturation: saturationValue }));

            uploadedImageObject.applyFilters();
            fbCanvas.requestRenderAll();
        }
    }

    function switchToBlack() {
        let blackTintMatrix = [
            0.0, 0.0, 0.0, 0, 0,
            0.0, 0.0, 0.0, 0, 0,
            0.0, 0.0, 0.0, 0, 0,
            0.0, 0.0, 0.0, 1, 0 
        ];

        applyFiltersWithColorMatrix(blackTintMatrix, 0, 0, 0);
    }

    function switchToWhite() {
        let whiteTintMatrix = [
            1.5, 1.5, 1.5, 0, 0,
            1.5, 1.5, 1.5, 0, 0,
            1.5, 1.5, 1.5, 0, 0,
            0, 0, 0, 1, 0 
        ];

        applyFiltersWithColorMatrix(whiteTintMatrix, 1, 1, 1);
    }

    function resetlogo() {
        if (uploadedImageObject && uploadedImageObject !== null) {
            uploadedImageObject.filters = [];
            uploadedImageObject.applyFilters();
            fbCanvas.requestRenderAll();
        }
    }

    switchLogoToBlack?.addEventListener('click', switchToBlack);
    switchLogoToWhite?.addEventListener('click', switchToWhite);
    switchLogoToOriginal?.addEventListener('click', resetlogo);

});

window.onload = (event) => {
        const elementof = document.querySelectorAll('input[name="mateOrientation"]');
        console.log('elementof : ', elementof);

        elementof.forEach(orientationButton => {
            orientationButton.removeAttribute("disabled");

            console.log('orientationButton : ', orientationButton);
            // if(orientationButton && orientationButton.value === "landscape"){
            //     console.log('selected orientationButton : ', orientationButton);
            //     orientationButton.click();  
            // }
            if ($('.customize-floor-mate--redesign').length === 1) {
                if (orientationButton && orientationButton.value === "landscape") {
                    console.log('selected orientationButton : ', orientationButton);
                    orientationButton.click();
                }
            }
            
        });

    $(document).on('click', '.mat-view-more-swatch', function() {
        $(this).find('.main-product__swatch-text').text('Show Less');
        $(this).removeClass('mat-view-more-swatch');  
        $(this).addClass('mat-view-less-swatch');  
        $(this).parents('.main-product__color-option').find('.deafult-hidden-swatches').show();    
    });
    $(document).on('click', '.mat-view-less-swatch', function() {
        $(this).find('.main-product__swatch-text').text('Show more');
        $(this).removeClass('mat-view-less-swatch');  
        $(this).addClass('mat-view-more-swatch');  
        $(this).parents('.main-product__color-option').find('.deafult-hidden-swatches').hide();    
    });
};

// 28-04-2025 js start here
$(document).ready(function () {
    let totalTabs = $('.customizer-tab-link').length;
    let currentTab = 1;


    function updateTabUI(tabIndex) {
        // Update tab header
        $('.customizer-tab-link').removeClass('active');
        $('.customizer-tab-link[data-tab="' + tabIndex + '"]').addClass('active');

        // Update content
        $('.customizer-tab-content').removeClass('active');
        $('#customizer-tab-' + tabIndex).addClass('active');

        // Button visibility
        if (tabIndex === 1) {
            $('.tab-btn-previous').css({ 'opacity': '0.5','pointer-events': 'none' });
        } else {
            $('.tab-btn-previous').css({ 'opacity': '1','pointer-events': 'all' });
        }
        $('.customise-section-tab-button .tab-btn-save').hide();
        // Next button label
        if (tabIndex === totalTabs) {
            $('.tab-btn-next').text('Buy Now').addClass('btn-buy-now');
            $('.tab-btn-next').text('Buy Now').removeClass('tab-btn-next');
            // $('.tab-btn--pre').removeClass('tab-btn-previous');

            $('.customise-section-tab-button .tab-btn-save').show();
            // $('.tab-btn--pre').text('Save').addClass('save-data');
            // $('.tab-btn--pre').text('Save').attr('data-save', 'false');
            console.log('buy now');
 
            // $(document).on('click', '.btn-buy-now', function () {
            //     console.log('click inner')
            //     const parentElement = document.querySelector('.main-product__customise-selection .main-product__checkout button');
            //     if (parentElement) {
            //         const clickEvent = new Event('click', {
            //             bubbles: true,
            //             cancelable: true
            //         });
            //         parentElement.dispatchEvent(clickEvent);
            //     }
            // });
        } else {
            $('.tab-btn-next').text('NEXT');
        }
    }

    // Initial button setup
    updateTabUI(currentTab);

    // Manual tab click
    $(document).on('click', '.customizer-tab-link', function () {
        currentTab = parseInt($(this).attr('data-tab'));
        updateTabUI(currentTab);
    });

    // Next button click
    // $(document).on('click', '.tab-btn-next', function () {
    //     console.log('next button click')
    //     var width = parseFloat($('input[name="width"]').val()); // Adjust selector as needed
          
    //     console.log(width)
    //     var length = parseFloat($('input[name="length"]').val()); // Adjust selector as needed
         
    //     if (width < 50 ) {
    //         $('input[name="width"]').parents('.custom-widht-grid').find('.size-error-message').show();
    //         return; // Stop further execution
    //     }
    //     if ( width > 200 ) {
    //         $('input[name="width"]').parents('.custom-widht-grid').find('.size-error-message--max').show();
    //         return; // Stop further execution
    //     }
       
    //     if (length != '' && length > 550) {
    //         $('input[name="length"]').parents('.custom-widht-grid').find('.size-error-message').show();
    //         return; // Stop further execution
    //     }
    //     if (currentTab < totalTabs) { 
    //         currentTab++;
    //         updateTabUI(currentTab);
    //     } else {
    //         // Add to Cart logic
    //         console.log("Add to cart action triggered");
    //         // e.g. $('form').submit();
    //     }
    // });
    

    $(document).on('click', '.tab-btn-next', function () {
        console.log('next button click');
        var $widthInput = $('input[name="width"]:visible');
        var $lengthInput = $('input[name="length"]:visible');
        var widthVisible = $widthInput.length > 0;
        var lengthVisible = $lengthInput.length > 0;
    
        var width = parseFloat($widthInput.val()); 
        var length = parseFloat($lengthInput.val()); 
    
        // Check if inputs are not blank
        if ($widthInput.val() === '' && widthVisible) {
            console.log('Please fill out both width and length');
            $('input[name="width"]').parents('.custom-widht-grid').find('.size-error-message--required').show();
            return; // Stop further execution
        }
        if ($lengthInput.val() === '' && lengthVisible) {
            console.log('Please fill out both width and length');
            $('input[name="length"]').parents('.custom-widht-grid').find('.size-error-message-length--required').show();
            return; // Stop further execution
        }
    
        // Run error checks only if both width and length inputs are visible
        if (widthVisible && lengthVisible) {
    
            if (width < 50) {
                $widthInput.parents('.custom-widht-grid').find('.size-error-message').show();
                $('input[name="width"]').parents('.custom-widht-grid').find('.size-error-message--required').hide();
                return; // Stop further execution
            }
            if (width > 200) {
                $widthInput.parents('.custom-widht-grid').find('.size-error-message--max').show();
                $('input[name="width"]').parents('.custom-widht-grid').find('.size-error-message--required').hide();
                return; // Stop further execution
            }
           

            if (length !== '' && length < 50) {
                $lengthInput.parents('.custom-widht-grid').find('.size-error-message--min').show();
                return; // Stop further execution
            }

            if (length !== '' && length > 550) { 
                $lengthInput.parents('.custom-widht-grid').find('.size-error-message').show();
                return; // Stop further execution
            }
        }
    
        if (currentTab < totalTabs) { 
            currentTab++;
            updateTabUI(currentTab);
        } else {
            // Add to Cart logic
            console.log("Add to cart action triggered");
            // e.g. $('form').submit();
        }
    });
    
    

    
   
    

    // Previous button click
    $(document).on('click', '.tab-btn-previous', function () {
        $('.tab-btn-next').removeClass('btn-buy-now');
        $('.tab--btn').removeClass('btn-buy-now');
        $('.tab--btn').addClass('tab-btn-next');

        if (currentTab > 1) {
            currentTab--;
            updateTabUI(currentTab);
        }
    });

    // Hide all steps except the first
  $(".step").hide();
  $("#step-1").show();

  // Next step
  $(document).on("click", ".js-next-step", function () {
   
    let currentStep = $(this).closest(".step");
    let nextStepId = $(this).data("next");
    currentStep.hide();
    $("#" + nextStepId).fadeIn();
    console.log("test", nextStepId); 

    console.log("steps attr : ", $(this).attr('data-next'));

    if($(this).attr('data-next') === 'step-3'){
        console.log("Matched steps attr : ", $(this).attr('data-next'));
        console.log("Attr input : ", $('input[name="mateOrientation"][value="landscape"]'));
        setTimeout(() => {
            const input = document.querySelector('input[name="mateOrientation"][value="landscape"]');
            const event = new Event('change', {
                bubbles: true,  // Optional: to make the event bubble up
                cancelable: true  // Optional: to allow preventing default behavior
            });
            input.dispatchEvent(event);
        }, 1000);
    }
  });

//   $(document).on("click", ".signup--btn", function () {
   
//     let currentStep = $(this).closest(".step");
//     let nextStepId = $(this).data("next");
//     let firstName = $('input[name="firstname"]').val().trim();
//     let lastName = $('input[name="lastname"]').val().trim();
//     if(firstName == '' && lastName == ''){
//        $('.firstNameError').text('please enter first name');
//     }else{
//         currentStep.hide();
//         $("#" + nextStepId).fadeIn();
//         console.log("test", nextStepId); 
    
//         console.log("steps attr : ", $(this).attr('data-next'));
    
//         if($(this).attr('data-next') === 'step-3'){
//             console.log("Matched steps attr : ", $(this).attr('data-next'));
//             console.log("Attr input : ", $('input[name="mateOrientation"][value="landscape"]'));
//             setTimeout(() => {
//                 const input = document.querySelector('input[name="mateOrientation"][value="landscape"]');
//                 const event = new Event('change', {
//                     bubbles: true,  // Optional: to make the event bubble up
//                     cancelable: true  // Optional: to allow preventing default behavior
//                 });
//                 input.dispatchEvent(event);
//             }, 1000);
//         }
//     } 
    
//   });



// working


$(document).on("click", ".signup--btn", function () {
    let currentStep = $(this).closest(".step");
    let nextStepId = $(this).data("next");

    let firstName = $('input[name="firstname"]').val().trim();
    let lastName = $('input[name="lastname"]').val().trim();
    let email = $('input[name="email"]').val().trim();

    // Clear previous errors
    $('.firstNameError').text('');
    $('.lastNameError').text('');
    $('.emailError').text('');

    let hasError = false;

    if (firstName === '') {
        $('.firstNameError').text('Please enter first name');
        hasError = true;
    }

    if (lastName === '') {
        $('.lastNameError').text('Please enter last name');
        hasError = true;
    }

    if (email === '') {
        $('.emailError').text('Please enter email');
        hasError = true;
    } else {
        // Basic email format check
        let emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(email)) {
            $('.emailError').text('Please enter a valid email address');
            hasError = true;
        }
    }

    if (hasError) {
        return; // stop if there are errors
    }

    // If no errors, proceed
    currentStep.hide();
    $("#" + nextStepId).fadeIn();
    console.log("test", nextStepId);

    console.log("steps attr:", $(this).attr('data-next'));
    let customer_firstname = $("input[name='firstname']").val();
    let customer_surname = $("input[name='lastname']").val();
    let customer_email = $("input[name='email']").val();
    let customerData = {};
    customerData["Firstname"] = customer_firstname;
    customerData["Surname"] = customer_surname;
    customerData["Email"] = customer_email;
    $.ajax({
        url: "https://firstmatsproofs.co.uk/firstmatsproofs.co.uk/eq-pdp-image/postdata.php?step_one=true",
        method: "POST",
        dataType: "JSON", 
        contentType: "application/json; charset=utf-8",
        data: JSON.stringify(customerData),
        success: function (data) {
          // console.log("submittted form data", customerData);
          $(".secure-checkout__form").addClass("form-submit-success");
        },
        error: function (data) {
          // console.log("error ", data);
          if ($(".secure-checkout__form").hasClass("form-submit-success")) {
            $(".secure-checkout__form").removeClass("form-submit-success");
          }
        },
      });

    
    if ($(this).attr('data-next') === 'step-3') {
        console.log("Matched steps attr:", $(this).attr('data-next'));
        console.log("Attr input:", $('input[name="mateOrientation"][value="landscape"]'));
        setTimeout(() => {
            const input = document.querySelector('input[name="mateOrientation"][value="landscape"]');
            const event = new Event('change', {
                bubbles: true,
                cancelable: true
            });
            input.dispatchEvent(event);
        }, 1000);
    }
});



  // Previous step
  $(".js-prev-step").on("click", function () {
    let currentStep = $(this).closest(".step");
    let prevStepId = $(this).data("prev");
    currentStep.hide();
    $("#" + prevStepId).fadeIn();
  });
  

  function applyColorToggle() {
    let visibleCount = window.innerWidth <= 575 ? 11 : 17;
    let colors = $('.customise-section.new-customize-ui .main-product__color-option .main-product__color-swatch');
    
    // Remove any previous toggleWrapper to avoid duplicates
    $('.more-less-button__wrap').remove();
    colors.show(); // Show all before hiding required ones
  
    // Hide items after visibleCount
    colors.slice(visibleCount).hide();
  
    // Create and insert toggle button
    let toggleWrapper = $('<div class="more-less-button__wrap"><button id="toggleButton" class="more-less-button">Show more +</button></div>');
    colors.eq(visibleCount - 1).after(toggleWrapper);
  
    // Click event (remove previous handlers to prevent stacking)
    toggleWrapper.off('click').on('click', 'button', function () {
      if (colors.filter(':hidden').length) {
        colors.css('display', 'inline-block');
        colors.last().after(toggleWrapper);
        $(this).text('Show less -');
      } else {
        colors.slice(visibleCount).hide();
        colors.eq(visibleCount - 1).after(toggleWrapper);
        $(this).text('Show more +');
      }
    });
  }
  
  // Initial call
  applyColorToggle();
  
  // Call on window resize (with debounce to improve performance)
  let resizeTimeout;
  $(window).on('resize', function () {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(applyColorToggle, 200);
  });
  


  $(document).on('click', '.btn-landscape-mobile', function () {
    $(this).addClass('active').siblings().removeClass('active');
    $('#landscape').trigger('click');
    console.log('click landscape');
  });
  
  $(document).on('click', '.btn-portrait-mobile', function () {
    $(this).addClass('active').siblings().removeClass('active');
    $('#portrait').trigger('click');
    console.log('click portrait');
  });
});
  // 28-04-2025 js start here


  $(document).on('click', '.btn-buy-now', function () {
    console.log('click inner')
    const parentElement = document.querySelector('.main-product__customise-selection .main-product__checkout button');
    if (parentElement) {
        const clickEvent = new Event('click', {
            bubbles: true,
            cancelable: true
        });
        parentElement.dispatchEvent(clickEvent);
    }
});

$(document).on("click", ".save-data", function (e) {
    e.preventDefault();
     $(this).attr('data-save', 'true');
      const $button = $(this);
       let dotCount = 0;
        $button.text('Please wait, saving');
        dotInterval = setInterval(function () {
    dotCount = (dotCount + 1) % 4; // 0, 1, 2, 3
    let dots = '.'.repeat(dotCount);
    $button.text('Please wait, saving' + dots);
  }, 500);
setTimeout(function () {
    clearInterval(dotInterval);
    $button.text('Design Saved!');
  }, 3000);
    //   $('.save-data').text('Please wait, saving...');
      $('.save-data').css('pointer-evetns', 'none');
     const parentElement = document.querySelector('.main-product__customise-selection .main-product__checkout button');
    if (parentElement) {
        const clickEvent = new Event('click', {
            bubbles: true,
            cancelable: true
        });
        parentElement.dispatchEvent(clickEvent);
    }
    
   
});
